import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet, apiPost } from "../utils/api_service";
const initialState = {
	salesExecutive: [],
	saleExcutiveObject: {},
	area: [],
	salesExecutiveObject: {},
	salesExecutiveWithCheckInOut: [],
	salesPersonByArea: [],
	salesPersonByAreaAndStockHolderType: [],
	assignedSalesTeamByBeatId: [],
	salesExecutiveByAreaAndStockHolderType: [],
	salesExecutiveByAreaAndStockHolderTypeForLeave: [],
	salesExecutiveByAreaAndStockHolderTypeForClaim: [],
	salesTeamByUserTypeAndTaluka: [],
	salesPersonByAreaAndStockHolderTypeForClaimStructure: [],
	salesTeamWithoutConfigurationByArea: [],
	monthlyClaimStatus: [],
	reportingAuthority: {},
	salesExecutiveAnalysis: {},
	driverByStockHolder: [],
	salesExecutiveByStockHolderType: [],
	salesExecutiveBelowTeam: [],
	salesTeamConfiguration: [],
};
let URL = endpoints.salesExecutive;
const salesExecutiveSlice = createSlice({
	name: "salesExecutive",
	initialState,
	reducers: {
		salesExecutiveSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				salesExecutive: row,
			};
		},

		salesExecutiveByStockHolderTypeSuccess: (
			state = cloneDeep(initialState),
			action,
		) => {
			const { row } = action.payload;
			return {
				...state,
				salesExecutiveByStockHolderType: row,
			};
		},

		monthlyClaimStatusSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				monthlyClaimStatus: row,
			};
		},

		salesPersonByAreaAndStockHolderTypeSuccess: (
			state = cloneDeep(initialState),
			action,
		) => {
			const { row } = action.payload;
			return {
				...state,
				salesPersonByAreaAndStockHolderType: row,
			};
		},

		salesExecutiveObjectSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				saleExcutiveObject: row,
			};
		},
		salesExecutiveWithCheckInOutSuccess: (
			state = cloneDeep(initialState),
			action,
		) => {
			const { row } = action.payload;
			return {
				...state,
				salesExecutiveWithCheckInOut: row,
			};
		},

		salesExecutiveObjectSuccess: (state = cloneDeep(initialState), action) => {
			const { salesExecutiveData } = action.payload;
			return {
				...state,
				salesExecutiveObject: salesExecutiveData,
			};
		},

		areaSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				area: row,
			};
		},

		salesPersonSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				salesPersonByArea: row,
			};
		},

		assignedSalesExecutieByBeatIdSuccess: (
			state = cloneDeep(initialState),
			action,
		) => {
			const { row } = action.payload;
			return {
				...state,
				assignedSalesTeamByBeatId: row,
			};
		},

		salesExecutiveByAreaAndStockHolderTypeIdSuccess: (
			state = cloneDeep(initialState),
			action,
		) => {
			const { row } = action.payload;
			return {
				...state,
				salesExecutiveByAreaAndStockHolderType: row,
			};
		},

		salesExecutiveByAreaAndStockHolderTypeForLeaveSuccess: (
			state = cloneDeep(initialState),
			action,
		) => {
			const { row } = action.payload;
			return {
				...state,
				salesExecutiveByAreaAndStockHolderTypeForLeave: row,
			};
		},

		salesExecutiveByAreaAndStockHolderTypeForClaimSuccess: (
			state = cloneDeep(initialState),
			action,
		) => {
			const { row } = action.payload;
			return {
				...state,
				salesExecutiveByAreaAndStockHolderTypeForClaim: row,
			};
		},

		salesTeamByUserTypeAndTalukaSuccess: (
			state = cloneDeep(initialState),
			action,
		) => {
			const { row } = action.payload;
			return {
				...state,
				salesTeamByUserTypeAndTaluka: row,
			};
		},

		salesPersonByAreaAndStockHolderTypeForClaimStructureSuccess: (
			state = cloneDeep(initialState),
			action,
		) => {
			const { row } = action.payload;
			return {
				...state,
				salesPersonByAreaAndStockHolderTypeForClaimStructure: row,
			};
		},

		salesTeamWithoutConfigurationByAreaSuccess: (
			state = cloneDeep(initialState),
			action,
		) => {
			const { row } = action.payload;
			return {
				...state,
				salesTeamWithoutConfigurationByArea: row,
			};
		},

		reportingAuthoritySuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				reportingAuthority: row,
			};
		},

		salesExecutiveAnalysisSuccess: (
			state = cloneDeep(initialState),
			action,
		) => {
			const { row } = action.payload;
			return {
				...state,
				salesExecutiveAnalysis: row,
			};
		},

		driverByStockHolderSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				driverByStockHolder: row,
			};
		},

		salesExecutiveBelowTeamSuccess: (
			state = cloneDeep(initialState),
			action,
		) => {
			const { row } = action.payload;
			return {
				...state,
				salesExecutiveBelowTeam: row,
			};
		},

		salesTeamConfigurationSuccess: (
			state = cloneDeep(initialState),
			action,
		) => {
			const { row } = action.payload;
			return {
				...state,
				salesTeamConfiguration: row,
			};
		},

		resetState: (state = cloneDeep(initialState), action) => {
			return {
				...state,
				...initialState,
			};
		},
	},
});

export const {
	salesExecutiveSuccess,
	salesExecutiveByStockHolderTypeSuccess,
	monthlyClaimStatusSuccess,
	salesExecutiveObjectSuccess,
	salesExecutiveWithCheckInOutSuccess,
	areaSuccess,
	salesPersonByAreaAndStockHolderTypeSuccess,
	salesPersonSuccess,
	assignedSalesExecutieByBeatIdSuccess,
	salesExecutiveByAreaAndStockHolderTypeIdSuccess,
	salesExecutiveByAreaAndStockHolderTypeForLeaveSuccess,
	salesExecutiveByAreaAndStockHolderTypeForClaimSuccess,
	salesTeamByUserTypeAndTalukaSuccess,
	salesPersonByAreaAndStockHolderTypeForClaimStructureSuccess,
	salesTeamWithoutConfigurationByAreaSuccess,
	reportingAuthoritySuccess,
	salesExecutiveAnalysisSuccess,
	driverByStockHolderSuccess,
	salesExecutiveBelowTeamSuccess,
	salesTeamConfigurationSuccess,
	resetState,
} = salesExecutiveSlice.actions;

export default salesExecutiveSlice.reducer;

export const getSalesExecutive =
	({ stockStakeHolderId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/by-stock-stake-holder-type-id?stockStakeHolderTypeIds=" +
					stockStakeHolderId,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							accessRoleId:
								salesExecutiveObject.accessRoleId === null
									? ""
									: salesExecutiveObject.accessRoleId,
							employeeCode:
								salesExecutiveObject.employeeCode === null
									? ""
									: salesExecutiveObject.employeeCode,
							regionObj:
								salesExecutiveObject.region === null
									? ""
									: salesExecutiveObject.region,
							stateNames:
								salesExecutiveObject.stateNames === null
									? ""
									: salesExecutiveObject.stateNames,
							stockStakeHolderType:
								salesExecutiveObject.stockStakeHolderType === null
									? ""
									: salesExecutiveObject.stockStakeHolderType,
							type:
								salesExecutiveObject.type === null
									? ""
									: salesExecutiveObject.type,
							userId:
								salesExecutiveObject.userId === null
									? ""
									: salesExecutiveObject.userId,
							areaList:
								salesExecutiveObject.areaList === null
									? ""
									: salesExecutiveObject.areaList,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.prefix !== null
									? salesExecutiveObject.name +
										"(" +
										salesExecutiveObject.stockStakeHolderType.prefix +
										")"
									: "",
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							regionName:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.name
									? salesExecutiveObject.region.name
									: "",
							region:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.id
									? salesExecutiveObject.region.id
									: "",
							zoneNames:
								salesExecutiveObject.zoneNames !== null
									? salesExecutiveObject.zoneNames
									: "",
							areaNames:
								salesExecutiveObject.areaNames !== null
									? salesExecutiveObject.areaNames
									: "",

							reportingManagerId:
								salesExecutiveObject.reportingManagerId !== null
									? salesExecutiveObject.reportingManagerId
									: "",

							reportingManagerTypeId:
								salesExecutiveObject.reportingManagerTypeId !== null
									? salesExecutiveObject.reportingManagerTypeId
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesExecutiveForReportingManager =
	({ stockStakeHolderId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/by-stock-stake-holder-type-id?stockStakeHolderTypeIds=" +
					stockStakeHolderId,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							accessRoleId:
								salesExecutiveObject.accessRoleId === null
									? ""
									: salesExecutiveObject.accessRoleId,
							employeeCode:
								salesExecutiveObject.employeeCode === null
									? ""
									: salesExecutiveObject.employeeCode,
							regionObj:
								salesExecutiveObject.region === null
									? ""
									: salesExecutiveObject.region,
							stateNames:
								salesExecutiveObject.stateNames === null
									? ""
									: salesExecutiveObject.stateNames,
							stockStakeHolderType:
								salesExecutiveObject.stockStakeHolderType === null
									? ""
									: salesExecutiveObject.stockStakeHolderType,
							type:
								salesExecutiveObject.type === null
									? ""
									: salesExecutiveObject.type,
							userId:
								salesExecutiveObject.userId === null
									? ""
									: salesExecutiveObject.userId,
							areaList:
								salesExecutiveObject.areaList === null
									? ""
									: salesExecutiveObject.areaList,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.employeeCode !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.employeeCode +
										")"
									: "",
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							regionName:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.name
									? salesExecutiveObject.region.name
									: "",
							region:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.id
									? salesExecutiveObject.region.id
									: "",
							zoneNames:
								salesExecutiveObject.zoneNames !== null
									? salesExecutiveObject.zoneNames
									: "",
							areaNames:
								salesExecutiveObject.areaNames !== null
									? salesExecutiveObject.areaNames
									: "",

							reportingManagerId:
								salesExecutiveObject.reportingManagerId !== null
									? salesExecutiveObject.reportingManagerId
									: "",

							reportingManagerTypeId:
								salesExecutiveObject.reportingManagerTypeId !== null
									? salesExecutiveObject.reportingManagerTypeId
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesExecutiveByStockHolderType =
	({ stockStakeHolderId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/by-stock-stake-holder-type-id?stockStakeHolderTypeIds=" +
					stockStakeHolderId,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.employeeCode !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.employeeCode +
										")"
									: "",
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							regionName:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.name
									? salesExecutiveObject.region.name
									: "",
							region:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.id
									? salesExecutiveObject.region.id
									: "",
							zoneNames:
								salesExecutiveObject.zoneNames !== null
									? salesExecutiveObject.zoneNames
									: "",
							areaNames:
								salesExecutiveObject.areaNames !== null
									? salesExecutiveObject.areaNames
									: "",

							reportingManagerId:
								salesExecutiveObject.reportingManagerId !== null
									? salesExecutiveObject.reportingManagerId
									: "",

							reportingManagerTypeId:
								salesExecutiveObject.reportingManagerTypeId !== null
									? salesExecutiveObject.reportingManagerTypeId
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveByStockHolderTypeSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesExecutiveWithStockHolderIdWithoutSelf =
	({ stockStakeHolderTypeIds }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/by-stock-stake-holder-type-id-with-out-self?stockStakeHolderTypeIds=" +
					stockStakeHolderTypeIds,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name === null
									? ""
									: salesExecutiveObject.name,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							regionName:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.name
									? salesExecutiveObject.region.name
									: "",
							region:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.id
									? salesExecutiveObject.region.id
									: "",
							zoneNames:
								salesExecutiveObject.zoneNames !== null
									? salesExecutiveObject.zoneNames
									: "",
							areaNames:
								salesExecutiveObject.areaNames !== null
									? salesExecutiveObject.areaNames
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesExecutiveWithStockHolderWithLoginUserAndType =
	({ stockStakeHolderTypeIds }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/by-login-user-and-type?stockStakeHolderTypeIds=" +
					stockStakeHolderTypeIds,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name === null
									? ""
									: salesExecutiveObject.name,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,

							stockStakeHolderType:
								salesExecutiveObject.stockStakeHolderType !== null
									? ""
									: salesExecutiveObject.stockStakeHolderType,

							stockStakeHolderTypeId:
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.id !== null
									? ""
									: salesExecutiveObject.stockStakeHolderType.id,

							stockStakeHolderTypeName:
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.name !== null
									? ""
									: salesExecutiveObject.stockStakeHolderType.name,
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const setSalesExecutiveWithStockHolderWithLoginUserAndType =
	({ row }) =>
	async (dispatch) => {
		dispatch(salesExecutiveSuccess({ row }));
	};

export const getSalesExecutiveByAreaAndStockHolderType =
	({ dataJson }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/with-admin-by-areas-and-stock-stake_holder-type",
				postBody: dataJson,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name === null
									? ""
									: salesExecutiveObject.name,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							regionName:
								salesExecutiveObject.regionName !== null
									? salesExecutiveObject.regionName
									: "",
							region:
								salesExecutiveObject.regionId !== null
									? salesExecutiveObject.regionId
									: "",
							zoneNames:
								salesExecutiveObject.zoneNames !== null
									? salesExecutiveObject.zoneNames
									: "",
							areaNames:
								salesExecutiveObject.areaNames !== null
									? salesExecutiveObject.areaNames
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveByAreaAndStockHolderTypeIdSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesExecutiveByAreaAndStockHolderTypeForLeave =
	({ dataJson }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/with-admin-by-areas-and-stock-stake_holder-type",
				postBody: dataJson,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name === null
									? ""
									: salesExecutiveObject.name,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							regionName:
								salesExecutiveObject.regionName !== null
									? salesExecutiveObject.regionName
									: "",
							region:
								salesExecutiveObject.regionId !== null
									? salesExecutiveObject.regionId
									: "",
							zoneNames:
								salesExecutiveObject.zoneNames !== null
									? salesExecutiveObject.zoneNames
									: "",
							areaNames:
								salesExecutiveObject.areaNames !== null
									? salesExecutiveObject.areaNames
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesExecutiveData;
					});
					dispatch(
						salesExecutiveByAreaAndStockHolderTypeForLeaveSuccess({ row }),
					);
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesExecutiveByAreaAndStockHolderTypeForClaim =
	({ dataJson }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/with-admin-by-areas-and-stock-stake_holder-type",
				postBody: dataJson,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name === null
									? ""
									: salesExecutiveObject.name,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							regionName:
								salesExecutiveObject.regionName !== null
									? salesExecutiveObject.regionName
									: "",
							region:
								salesExecutiveObject.regionId !== null
									? salesExecutiveObject.regionId
									: "",
							zoneNames:
								salesExecutiveObject.zoneNames !== null
									? salesExecutiveObject.zoneNames
									: "",
							areaNames:
								salesExecutiveObject.areaNames !== null
									? salesExecutiveObject.areaNames
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesExecutiveData;
					});
					dispatch(
						salesExecutiveByAreaAndStockHolderTypeForClaimSuccess({ row }),
					);
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesExecutiveByUserType =
	({ userTypeId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/by-user-type-id?userTypeIds=" + userTypeId,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							employeeCode:
								salesExecutiveObject.employeeCode === null
									? "-"
									: salesExecutiveObject.employeeCode,
							prefix:
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.prefix !== null
									? salesExecutiveObject.stockStakeHolderType.prefix
									: "",
							name:
								salesExecutiveObject.name != null
									? salesExecutiveObject.name +
										(salesExecutiveObject.stockStakeHolderType !== null &&
										salesExecutiveObject.stockStakeHolderType.prefix !== null
											? " (" +
												salesExecutiveObject.stockStakeHolderType.prefix +
												")"
											: "")
									: "",
							stockStakeHolderType:
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.name !== null
									? salesExecutiveObject.stockStakeHolderType.name
									: "",
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							regionName:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.name
									? salesExecutiveObject.region.name
									: "",
							region:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.id
									? salesExecutiveObject.region.id
									: "",
							zoneNames:
								salesExecutiveObject.zoneNames !== null
									? salesExecutiveObject.zoneNames
									: "",
							areaNames:
								salesExecutiveObject.areaNames !== null
									? salesExecutiveObject.areaNames
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesExecutiveData;
					});
					dispatch(salesPersonSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getAllSalesExecutiveByUserType =
	({ userTypeId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/all-by-user-type-ids?userTypeIds=" + userTypeId,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							employeeCode:
								salesExecutiveObject.employeeCode === null
									? "-"
									: salesExecutiveObject.employeeCode,
							prefix:
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.prefix !== null
									? salesExecutiveObject.stockStakeHolderType.prefix
									: "",
							name:
								salesExecutiveObject.name != null
									? salesExecutiveObject.name +
										(salesExecutiveObject.stockStakeHolderType !== null &&
										salesExecutiveObject.stockStakeHolderType.prefix !== null
											? " (" +
												salesExecutiveObject.stockStakeHolderType.prefix +
												")"
											: "")
									: "",
							stockStakeHolderType:
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.name !== null
									? salesExecutiveObject.stockStakeHolderType.name
									: "",
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							regionName:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.name
									? salesExecutiveObject.region.name
									: "",
							region:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.id
									? salesExecutiveObject.region.id
									: "",
							zoneNames:
								salesExecutiveObject.zoneNames !== null
									? salesExecutiveObject.zoneNames
									: "",
							areaNames:
								salesExecutiveObject.areaNames !== null
									? salesExecutiveObject.areaNames
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesExecutiveData;
					});
					dispatch(salesPersonSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesExecutiveByUserTypeAndRegion =
	({ userTypeId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL + "/by-user-type-ids-and-user-regions?userTypeIds=" + userTypeId,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							prefix:
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.prefix !== null
									? salesExecutiveObject.stockStakeHolderType.prefix
									: "",
							name:
								salesExecutiveObject.name != null
									? salesExecutiveObject.name +
										(salesExecutiveObject.stockStakeHolderType !== null &&
										salesExecutiveObject.stockStakeHolderType.prefix !== null
											? " (" +
												salesExecutiveObject.stockStakeHolderType.prefix +
												")"
											: "")
									: "",
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							regionName:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.name
									? salesExecutiveObject.region.name
									: "",
							region:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.id
									? salesExecutiveObject.region.id
									: "",
							zoneNames:
								salesExecutiveObject.zoneNames !== null
									? salesExecutiveObject.zoneNames
									: "",
							areaNames:
								salesExecutiveObject.areaNames !== null
									? salesExecutiveObject.areaNames
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesExecutiveData;
					});
					dispatch(salesPersonSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesExecutiveByArea = () => async (dispatch) => {
	try {
		const response = apiGet({
			url: URL + "/get-sales-person-by-areas",
		}).then(({ data, success }) => {
			if (success) {
				const row = data.data.map((salesExecutiveObject, index) => {
					let salesExecutiveData = {
						index: index + 1,
						id: salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
						userName:
							salesExecutiveObject.userName === null
								? ""
								: salesExecutiveObject.userName,
						employeeCode:
							salesExecutiveObject.employeeCode === null
								? ""
								: salesExecutiveObject.employeeCode,
						name:
							salesExecutiveObject.name === null
								? ""
								: salesExecutiveObject.name,
						salesTeamType:
							salesExecutiveObject.stockStakeHolderType !== null &&
							salesExecutiveObject.stockStakeHolderType.name !== null
								? salesExecutiveObject.stockStakeHolderType.name
								: "",
						salesTeamName:
							salesExecutiveObject.name !== null &&
							salesExecutiveObject.stockStakeHolderType !== null &&
							salesExecutiveObject.stockStakeHolderType.prefix !== null
								? salesExecutiveObject.name +
									" (" +
									salesExecutiveObject.stockStakeHolderType.prefix +
									")"
								: "",
						reportingManagerName:
							salesExecutiveObject.reportingManagerName === null
								? ""
								: salesExecutiveObject.reportingManagerName,
						reportingManagerTypeName:
							salesExecutiveObject.reportingManagerTypeName === null
								? ""
								: salesExecutiveObject.reportingManagerTypeName,
						address:
							salesExecutiveObject.address === null
								? ""
								: salesExecutiveObject.address,
						regionName:
							salesExecutiveObject.region !== null &&
							salesExecutiveObject.region.name
								? salesExecutiveObject.region.name
								: "",
						region:
							salesExecutiveObject.region !== null &&
							salesExecutiveObject.region.id
								? salesExecutiveObject.region.id
								: "",
						stateNames:
							salesExecutiveObject.stateNames !== null
								? salesExecutiveObject.stateNames
								: "-",
						zoneNames:
							salesExecutiveObject.zoneNames !== null
								? salesExecutiveObject.zoneNames
								: "-",
						areaNames:
							salesExecutiveObject.areaNames !== null
								? salesExecutiveObject.areaNames
								: "",
						emailId:
							salesExecutiveObject.emailId === null
								? ""
								: salesExecutiveObject.emailId,
						isActive:
							salesExecutiveObject.isActive === null
								? ""
								: salesExecutiveObject.isActive,
						contactNo:
							salesExecutiveObject.contactNo === null
								? ""
								: salesExecutiveObject.contactNo,
						whatsAppNo:
							salesExecutiveObject.whatsAppNo === null
								? ""
								: salesExecutiveObject.whatsAppNo,
						type:
							salesExecutiveObject.type === null
								? ""
								: salesExecutiveObject.type == 0
									? "Value Wise Target"
									: salesExecutiveObject.type == 1
										? "Beat Wise Target"
										: "RU Wise Target",
					};
					return salesExecutiveData;
				});
				dispatch(salesExecutiveSuccess({ row }));
				return { response: row, success };
			}
			return { response: [], success };
		});
		return response;
	} catch (e) {
		return console.error(e.message);
	}
};

export const getSalesExecutiveByAreaOptimized = () => async (dispatch) => {
	try {
		const response = apiGet({
			url: URL + "/get-sales-person-by-areas-optimize",
		}).then(({ data, success }) => {
			if (success) {
				const row = data.data.map((salesExecutiveObject, index) => {
					let salesExecutiveData = {
						index: index + 1,
						id: salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
						userName:
							salesExecutiveObject.userName === null
								? ""
								: salesExecutiveObject.userName,
						employeeCode:
							salesExecutiveObject.employeeCode === null
								? ""
								: salesExecutiveObject.employeeCode,
						name:
							salesExecutiveObject.name === null
								? ""
								: salesExecutiveObject.name,
						salesTeamType:
							salesExecutiveObject.stockStakeHolderTypeName !== null
								? salesExecutiveObject.stockStakeHolderTypeName
								: "",
					};
					return salesExecutiveData;
				});
				dispatch(salesExecutiveSuccess({ row }));
				return { response: row, success };
			}
			return { response: [], success };
		});
		return response;
	} catch (e) {
		return console.error(e.message);
	}
};

export const getSalesExecutiveByAreaWithExtraInfoOptimized =
	() => async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/get-sales-person-by-areas-with-extra-info-optimize",
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							employeeCode:
								salesExecutiveObject.employeeCode === null
									? ""
									: salesExecutiveObject.employeeCode,
							name:
								salesExecutiveObject.name === null
									? ""
									: salesExecutiveObject.name,
							salesTeamType:
								salesExecutiveObject.stockStakeHolderTypeName !== null
									? salesExecutiveObject.stockStakeHolderTypeName
									: "",
							salesTeamName:
								salesExecutiveObject.salesTeamName !== null
									? salesExecutiveObject.salesTeamName
									: "",
							reportingManagerName:
								salesExecutiveObject.reportingTo !== null
									? salesExecutiveObject.reportingTo
									: "",
							reportingManagerTypeName:
								salesExecutiveObject.reportingToType !== null
									? salesExecutiveObject.reportingToType
									: "",
							regionName:
								salesExecutiveObject.region !== null
									? salesExecutiveObject.region
									: "",
							stateNames:
								salesExecutiveObject.states !== null
									? salesExecutiveObject.states
									: "",
							zoneNames:
								salesExecutiveObject.zones !== null
									? salesExecutiveObject.zones
									: "",
							areaNames:
								salesExecutiveObject.areas !== null
									? salesExecutiveObject.areas
									: "",

							emailId:
								salesExecutiveObject.emailId !== null
									? salesExecutiveObject.emailId
									: "",

							isActive:
								salesExecutiveObject.isActive !== null
									? salesExecutiveObject.isActive
									: "",
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesExecutiveByAreaId =
	({ areaId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL + "/not-in-beat-assign-daywise-header-by-area?areaId=" + areaId,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.prefix !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.stockStakeHolderType.prefix +
										")"
									: "",
							salesTeamName:
								salesExecutiveObject.name === null
									? ""
									: salesExecutiveObject.name,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							regionName:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.name
									? salesExecutiveObject.region.name
									: "",
							region:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.id
									? salesExecutiveObject.region.id
									: "",
							zoneNames:
								salesExecutiveObject.zoneNames !== null
									? salesExecutiveObject.zoneNames
									: "",
							areaNames:
								salesExecutiveObject.areaNames !== null
									? salesExecutiveObject.areaNames
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesExecutiveTypeByAreaId =
	({ areaId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/by-area?areaId=" + areaId,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.prefix !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.stockStakeHolderType.prefix +
										")"
									: "",
							salesTeamName:
								salesExecutiveObject.name === null
									? ""
									: salesExecutiveObject.name,

							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							regionName:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.name
									? salesExecutiveObject.region.name
									: "",
							region:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.id
									? salesExecutiveObject.region.id
									: "",
							zoneIds:
								salesExecutiveObject.zoneIds !== null
									? salesExecutiveObject.zoneIds
									: "",
							areaIds:
								salesExecutiveObject.areaIds !== null
									? salesExecutiveObject.areaIds
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getAreaByStockStakeHolderTypeIdAndZoneIds =
	({ StockStakeHolderTypeId, zoneIds }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/get-areas?StockStakeHolderTypeId=" +
					StockStakeHolderTypeId +
					"&zoneIds=" +
					zoneIds,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((areaObject, index) => {
						let areaData = {
							index: index + 1,
							id: areaObject.id === null ? "" : areaObject.id,
							name:
								areaObject.name === null
									? ""
									: areaObject.name + " (" + areaObject.shortName + ")",
							zoneName:
								areaObject.taluka !== null &&
								areaObject.taluka.district.zone.name
									? areaObject.taluka.district.zone.name
									: "",
							zone:
								areaObject.zone !== null && areaObject.taluka.district.zone.id
									? areaObject.taluka.district.zone.id
									: "",
							shortName:
								areaObject.shortName === null ? "" : areaObject.shortName,
							sortOrder:
								areaObject.sortOrder === null ? "" : areaObject.sortOrder,
						};
						return areaData;
					});
					dispatch(areaSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getAreaByStockStakeHolderTypeIdAndZoneIdsEdit =
	({ saleExcId, StockStakeHolderTypeId, zoneIds }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/" +
					saleExcId +
					"/get-areas-on-edit?StockStakeHolderTypeId=" +
					StockStakeHolderTypeId +
					"&zoneIds=" +
					zoneIds,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((areaObject, index) => {
						let areaData = {
							index: index + 1,
							id: areaObject.id === null ? "" : areaObject.id,
							name:
								areaObject.name === null
									? ""
									: areaObject.name + " (" + areaObject.shortName + ")",
							zoneName:
								areaObject.taluka !== null &&
								areaObject.taluka.district.zone.name
									? areaObject.taluka.district.zone.name
									: "",
							zone:
								areaObject.taluka !== null && areaObject.taluka.district.zone.id
									? areaObject.taluka.district.zone.id
									: "",
							shortName:
								areaObject.shortName === null ? "" : areaObject.shortName,
							sortOrder:
								areaObject.sortOrder === null ? "" : areaObject.sortOrder,
						};
						return areaData;
					});
					dispatch(areaSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};
export const getSalesExecutiveByBeatId =
	({ beatIds }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/by-beat?beatId=" + beatIds,
			}).then(({ data, success }) => {
				if (success) {
					dispatch(salesExecutiveObjectSuccess({ row: data.data }));
					return { response: data.data, success };
				}
				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesExecutiveByBeatIds =
	({ beatIds }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/by-beats?beatIds=" + beatIds,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							...salesExecutiveObject,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.prefix !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.stockStakeHolderType.prefix +
										")"
									: "",
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveSuccess({ row: row }));
					return { response: row, success };
				}
				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesExecutiveWithCheckInOut = () => async (dispatch) => {
	try {
		const response = apiGet({
			url: URL + "/sales-person-with-check-in-out",
		}).then(({ data, success }) => {
			if (success) {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name === null
									? ""
									: salesExecutiveObject.name,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							regionName:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.name
									? salesExecutiveObject.region.name
									: "",
							region:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.id
									? salesExecutiveObject.region.id
									: "",
							zoneIds:
								salesExecutiveObject.zoneIds !== null
									? salesExecutiveObject.zoneIds
									: "",
							areaIds:
								salesExecutiveObject.areaIds !== null
									? salesExecutiveObject.areaIds
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
							checkIn:
								salesExecutiveObject.checkInOut === null
									? "-"
									: salesExecutiveObject.checkInOut.checkInTime === null
										? "-"
										: salesExecutiveObject.checkInOut.checkInTime,
							checkOut:
								salesExecutiveObject.checkInOut === null
									? "-"
									: salesExecutiveObject.checkInOut.checkOutTime === null
										? "-"
										: salesExecutiveObject.checkInOut.checkOutTime,
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveWithCheckInOutSuccess({ row }));
					return { response: row, success };
				}
			}
			return { response: {}, success };
		});
		return response;
	} catch (e) {
		return console.error(e.message);
	}
};

export const getSalesExecutiveByLoginAreas = () => async (dispatch) => {
	try {
		const response = apiGet({
			url: URL + "/by-login-areas",
		}).then(({ data, success }) => {
			if (success) {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveName =
							salesExecutiveObject.name !== null
								? salesExecutiveObject.name
								: "";
						let stockStakeHolderTypeName =
							salesExecutiveObject.stockStakeHolderType !== null
								? salesExecutiveObject.stockStakeHolderType.prefix
								: "";
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							userId:
								salesExecutiveObject.userId === null
									? ""
									: salesExecutiveObject.userId,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							stockStakeHolderTypeId:
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.id
									? salesExecutiveObject.stockStakeHolderType.id
									: "",
							stockStakeHolderType:
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.name
									? salesExecutiveObject.stockStakeHolderType.name
									: "",
							name:
								salesExecutiveName + " ( " + stockStakeHolderTypeName + " )",
							whatsAppNo:
								salesExecutiveObject.whatsAppNo !== null
									? salesExecutiveObject.whatsAppNo
									: "",

							address:
								salesExecutiveObject.address !== null
									? salesExecutiveObject.address
									: "",

							employeeCode:
								salesExecutiveObject.employeeCode !== null
									? salesExecutiveObject.employeeCode
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
							type:
								salesExecutiveObject.type === null
									? ""
									: salesExecutiveObject.type,
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveSuccess({ row }));
					return { response: row, success };
				}
			}
			return { response: {}, success };
		});
		return response;
	} catch (e) {
		return console.error(e.message);
	}
};

export const getSalesPersonByArea =
	({ areaIds }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/get-all-sales-person-by-areas?areaIds=" + areaIds,
			}).then(({ data, success }) => {
				if (success) {
					if (success) {
						const row = data.data.map((salesExecutiveObject, index) => {
							let salesExecutiveData = {
								index: index + 1,
								id:
									salesExecutiveObject.id === null
										? ""
										: salesExecutiveObject.id,
								name:
									salesExecutiveObject.name === null
										? ""
										: salesExecutiveObject.name,
								address:
									salesExecutiveObject.address === null
										? ""
										: salesExecutiveObject.address,

								areaIds:
									salesExecutiveObject.areaIds !== null
										? salesExecutiveObject.areaIds
										: "",
								region:
									salesExecutiveObject.region !== null
										? salesExecutiveObject.region.name
										: "",

								address:
									salesExecutiveObject.region !== null
										? salesExecutiveObject.region
										: "",

								employeeCode:
									salesExecutiveObject.employeeCode !== null
										? salesExecutiveObject.employeeCode
										: "",

								emailId:
									salesExecutiveObject.emailId === null
										? ""
										: salesExecutiveObject.emailId,
								contactNo:
									salesExecutiveObject.contactNo === null
										? ""
										: salesExecutiveObject.contactNo,
								whatsAppNo:
									salesExecutiveObject.whatsAppNo === null
										? ""
										: salesExecutiveObject.whatsAppNo,

								isActive:
									salesExecutiveObject.isActive === null
										? ""
										: salesExecutiveObject.isActive,
								type:
									salesExecutiveObject.type === null
										? ""
										: salesExecutiveObject.type,
							};
							return salesExecutiveData;
						});
						dispatch(salesPersonSuccess({ row }));
						return { response: row, success };
					}
				}
				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesPersonByAreaPost =
	({ areaIdsJson }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/all-sales-person-by-areas",
				postBody: areaIdsJson,
			}).then(({ data, success }) => {
				if (success) {
					if (success) {
						const row = data.data.map((salesExecutiveObject, index) => {
							let salesExecutiveData = {
								index: index + 1,
								id:
									salesExecutiveObject.id === null
										? ""
										: salesExecutiveObject.id,
								name:
									salesExecutiveObject.name !== null &&
									salesExecutiveObject.stockStakeHolderType !== null &&
									salesExecutiveObject.stockStakeHolderType.prefix
										? salesExecutiveObject.name +
											" (" +
											salesExecutiveObject.stockStakeHolderType.prefix +
											")"
										: "",
								address:
									salesExecutiveObject.address === null
										? ""
										: salesExecutiveObject.address,

								areaIds:
									salesExecutiveObject.areaIds !== null
										? salesExecutiveObject.areaIds
										: "",
								region:
									salesExecutiveObject.region !== null
										? salesExecutiveObject.region.name
										: "",

								address:
									salesExecutiveObject.region !== null
										? salesExecutiveObject.region
										: "",

								employeeCode:
									salesExecutiveObject.employeeCode !== null
										? salesExecutiveObject.employeeCode
										: "",

								emailId:
									salesExecutiveObject.emailId === null
										? ""
										: salesExecutiveObject.emailId,
								contactNo:
									salesExecutiveObject.contactNo === null
										? ""
										: salesExecutiveObject.contactNo,
								whatsAppNo:
									salesExecutiveObject.whatsAppNo === null
										? ""
										: salesExecutiveObject.whatsAppNo,

								isActive:
									salesExecutiveObject.isActive === null
										? ""
										: salesExecutiveObject.isActive,
								type:
									salesExecutiveObject.type === null
										? ""
										: salesExecutiveObject.type,
							};
							return salesExecutiveData;
						});
						dispatch(salesPersonSuccess({ row }));
						return { response: row, success };
					}
				}
				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getInactiveSalesPersonByArea =
	({ areaIdsJson }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/get-all-inactive-sales-person-by-areas",
				postBody: areaIdsJson,
			}).then(({ data, success }) => {
				if (success) {
					if (success) {
						const row = data.data.map((salesExecutiveObject, index) => {
							let salesExecutiveData = {
								index: index + 1,
								id:
									salesExecutiveObject.id === null
										? ""
										: salesExecutiveObject.id,
								name:
									salesExecutiveObject.name === null
										? ""
										: salesExecutiveObject.name,
								address:
									salesExecutiveObject.address === null
										? ""
										: salesExecutiveObject.address,

								areaIds:
									salesExecutiveObject.areaIds !== null
										? salesExecutiveObject.areaIds
										: "",
								region:
									salesExecutiveObject.region !== null
										? salesExecutiveObject.region.name
										: "",

								address:
									salesExecutiveObject.region !== null
										? salesExecutiveObject.region
										: "",

								employeeCode:
									salesExecutiveObject.employeeCode !== null
										? salesExecutiveObject.employeeCode
										: "",

								emailId:
									salesExecutiveObject.emailId === null
										? ""
										: salesExecutiveObject.emailId,
								contactNo:
									salesExecutiveObject.contactNo === null
										? ""
										: salesExecutiveObject.contactNo,
								whatsAppNo:
									salesExecutiveObject.whatsAppNo === null
										? ""
										: salesExecutiveObject.whatsAppNo,

								isActive:
									salesExecutiveObject.isActive === null
										? ""
										: salesExecutiveObject.isActive,
								type:
									salesExecutiveObject.type === null
										? ""
										: salesExecutiveObject.type,
							};
							return salesExecutiveData;
						});
						dispatch(salesPersonSuccess({ row }));
						return { response: row, success };
					}
				}
				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesPersonByAreaAndStockHolderType =
	({ dataJson }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/by-areas-and-stock-stake-holder-types",
				postBody: dataJson,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name === null
									? ""
									: salesExecutiveObject.name,

							employeeCode:
								salesExecutiveObject.employeeCode !== null
									? salesExecutiveObject.employeeCode
									: "",

							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,

							areaIds:
								salesExecutiveObject.areaIds !== null
									? salesExecutiveObject.areaIds
									: "",
							regionName:
								salesExecutiveObject.regionName !== null
									? salesExecutiveObject.regionName
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
							type:
								salesExecutiveObject.type === null
									? ""
									: salesExecutiveObject.type,
							stockStakeHolderTypeId:
								salesExecutiveObject.stockStakeHolderTypeId === null
									? ""
									: salesExecutiveObject.stockStakeHolderTypeId,
							stockStakeHolderTypeName:
								salesExecutiveObject.stockStakeHolderTypeName === null
									? ""
									: salesExecutiveObject.stockStakeHolderTypeName,
							userId:
								salesExecutiveObject.userId === null
									? ""
									: salesExecutiveObject.userId,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
						};
						return salesExecutiveData;
					});
					dispatch(salesPersonByAreaAndStockHolderTypeSuccess({ row }));
					return { response: row, success };
				}

				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesPersonByAreaAndStockHolderTypeUpdated =
	({ dataJson }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/by-areas-and-stock-stake-holder-types-with-area-names",
				postBody: dataJson,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name === null
									? ""
									: salesExecutiveObject.name,

							employeeCode:
								salesExecutiveObject.employeeCode !== null
									? salesExecutiveObject.employeeCode
									: "",

							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,

							areaIds:
								salesExecutiveObject.areaIds !== null
									? salesExecutiveObject.areaIds
									: "",
							areaNames:
								salesExecutiveObject.areaNames !== null
									? salesExecutiveObject.areaNames
									: "",
							regionName:
								salesExecutiveObject.regionName !== null
									? salesExecutiveObject.regionName
									: "",
							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
							type:
								salesExecutiveObject.type === null
									? ""
									: salesExecutiveObject.type,
							stockStakeHolderTypeId:
								salesExecutiveObject.stockStakeHolderTypeId === null
									? ""
									: salesExecutiveObject.stockStakeHolderTypeId,
							stockStakeHolderTypeName:
								salesExecutiveObject.stockStakeHolderTypeName === null
									? ""
									: salesExecutiveObject.stockStakeHolderTypeName,
							userId:
								salesExecutiveObject.userId === null
									? ""
									: salesExecutiveObject.userId,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
						};
						return salesExecutiveData;
					});
					dispatch(salesPersonByAreaAndStockHolderTypeSuccess({ row }));
					return { response: row, success };
				}

				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const setSalesPersonByAreaAndStockHolderType =
	({ row }) =>
	async (dispatch) => {
		dispatch(salesPersonByAreaAndStockHolderTypeSuccess({ row }));
	};

export const getSalesPersonByAreaAndStockHolderTypeForClaimStructure =
	({ claimStructureHeaderId, dataJson }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url:
					URL +
					"/by-areas-and-stock-stake-holder-types-with-area-names-for-claim?claimStructureHeaderId=" +
					claimStructureHeaderId,
				postBody: dataJson,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							employeeCode:
								salesExecutiveObject.employeeCode !== null
									? salesExecutiveObject.employeeCode
									: "",
							name:
								salesExecutiveObject.name === null
									? ""
									: salesExecutiveObject.name,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,

							areaIds:
								salesExecutiveObject.areaIds !== null
									? salesExecutiveObject.areaIds
									: "",
							areaNames:
								salesExecutiveObject.areaNames !== null
									? salesExecutiveObject.areaNames
									: "",
							regionName:
								salesExecutiveObject.regionName !== null
									? salesExecutiveObject.regionName
									: "",
							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
							type:
								salesExecutiveObject.type === null
									? ""
									: salesExecutiveObject.type,
							stockStakeHolderTypeId:
								salesExecutiveObject.stockStakeHolderTypeId === null
									? ""
									: salesExecutiveObject.stockStakeHolderTypeId,
							stockStakeHolderTypeName:
								salesExecutiveObject.stockStakeHolderTypeName === null
									? ""
									: salesExecutiveObject.stockStakeHolderTypeName,
							reportingManagerName:
								salesExecutiveObject.reportingManagerName === null
									? ""
									: salesExecutiveObject.reportingManagerName,
							reportingManagerTypeName:
								salesExecutiveObject.reportingManagerTypeName === null
									? ""
									: salesExecutiveObject.reportingManagerTypeName,

							userId:
								salesExecutiveObject.userId === null
									? ""
									: salesExecutiveObject.userId,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
						};
						return salesExecutiveData;
					});
					dispatch(
						salesPersonByAreaAndStockHolderTypeForClaimStructureSuccess({
							row,
						}),
					);
					return { response: row, success };
				}

				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const setSalesPersonByAreaAndStockHolderTypeForClaimStructure =
	({ row }) =>
	async (dispatch) => {
		dispatch(
			salesPersonByAreaAndStockHolderTypeForClaimStructureSuccess({ row }),
		);
	};

//Used in manual order
export const getAssignedSalesExecutiveByBeatId =
	({ beatId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/check-assigned-sales-teams-by-beat?beatId=" + beatId,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.salesTeam.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderType !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.stockStakeHolderType.prefix +
										")"
									: "",
							employeeCode:
								salesExecutiveObject.employeeCode !== null
									? salesExecutiveObject.employeeCode
									: "",

							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,

							areaIds:
								salesExecutiveObject.areaIds !== null
									? salesExecutiveObject.areaIds
									: "",
							areaNames:
								salesExecutiveObject.areaNames !== null
									? salesExecutiveObject.areaNames
									: "",
							regionName:
								salesExecutiveObject.regionName !== null
									? salesExecutiveObject.regionName
									: "",
							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
							type:
								salesExecutiveObject.type === null
									? ""
									: salesExecutiveObject.type,
							stockStakeHolderTypeId:
								salesExecutiveObject.stockStakeHolderType === null
									? ""
									: salesExecutiveObject.stockStakeHolderType.id,
							stockStakeHolderTypeName:
								salesExecutiveObject.stockStakeHolderType === null
									? ""
									: salesExecutiveObject.stockStakeHolderType.name,
							userId:
								salesExecutiveObject.userId === null
									? ""
									: salesExecutiveObject.userId,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
						};
						return salesExecutiveData;
					});

					dispatch(assignedSalesExecutieByBeatIdSuccess({ row }));
					return { response: row, success };
				}
				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesTeamByUserTypeAndTaluka =
	({ jsonForSave }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/by-stock-stake-holder-type-and-taluka",
				postBody: jsonForSave,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							userId:
								salesExecutiveObject.userId === null
									? ""
									: salesExecutiveObject.userId,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.name !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.stockStakeHolderType.name +
										")"
									: "",
							salesTeamName:
								salesExecutiveObject.name !== null
									? salesExecutiveObject.name
									: "",
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							employeeCode:
								salesExecutiveObject.employeeCode === null
									? ""
									: salesExecutiveObject.employeeCode,
							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							reportingManagerTypeId:
								salesExecutiveObject.reportingManagerTypeId === null
									? ""
									: salesExecutiveObject.reportingManagerTypeId,
							reportingManagerId:
								salesExecutiveObject.reportingManagerId === null
									? ""
									: salesExecutiveObject.reportingManagerId,
							regionId:
								salesExecutiveObject.regionId === null
									? ""
									: salesExecutiveObject.regionId,
							regionId:
								salesExecutiveObject.regionId === null
									? ""
									: salesExecutiveObject.regionId,
							zoneIds:
								salesExecutiveObject.zoneIds === null
									? ""
									: salesExecutiveObject.zoneIds,
							areaIds:
								salesExecutiveObject.areaIds === null
									? ""
									: salesExecutiveObject.areaIds,
							accessRoleId:
								salesExecutiveObject.accessRoleId === null
									? ""
									: salesExecutiveObject.accessRoleId,
							type:
								salesExecutiveObject.type === null
									? ""
									: salesExecutiveObject.type,
							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
							insertDateTime:
								salesExecutiveObject.insertDateTime === null
									? ""
									: salesExecutiveObject.insertDateTime,
							stockStakeHolderTypeId:
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.id !== null
									? salesExecutiveObject.stockStakeHolderType.id
									: "",
							stockStakeHolderTypeName:
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.name !== null
									? salesExecutiveObject.stockStakeHolderType.name
									: "",
						};
						return salesExecutiveData;
					});

					dispatch(salesTeamByUserTypeAndTalukaSuccess({ row }));
					return { response: row, success };
				}
				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesExecutiveTypeByUserTypeIdsAndAreaId =
	({ dataJson }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/by-user-type-ids-and-areas",
				postBody: dataJson,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.prefix !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.stockStakeHolderType.prefix +
										")"
									: "",
							salesTeamName:
								salesExecutiveObject.name === null
									? ""
									: salesExecutiveObject.name,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							regionName:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.name
									? salesExecutiveObject.region.name
									: "",
							region:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.id
									? salesExecutiveObject.region.id
									: "",
							zoneIds:
								salesExecutiveObject.zoneIds !== null
									? salesExecutiveObject.zoneIds
									: "",
							areaIds:
								salesExecutiveObject.areaIds !== null
									? salesExecutiveObject.areaIds
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesExecutiveTypeForFilter =
	({ dataJson }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/all-by-user-type-ids-and-areas",
				postBody: dataJson,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							employeeCode:
								salesExecutiveObject.employeeCode === null
									? ""
									: salesExecutiveObject.employeeCode,
							name:
								salesExecutiveObject.name === null
									? ""
									: salesExecutiveObject.name,
							salesTeamName:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.prefix !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.stockStakeHolderType.prefix +
										")"
									: "",
							reportingManagerName:
								salesExecutiveObject.reportingManagerName === null
									? ""
									: salesExecutiveObject.reportingManagerName,
							reportingManagerTypeName:
								salesExecutiveObject.reportingManagerTypeName === null
									? ""
									: salesExecutiveObject.reportingManagerTypeName,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							regionName:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.name
									? salesExecutiveObject.region.name
									: "",
							region:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.id
									? salesExecutiveObject.region.id
									: "",
							stateNames:
								salesExecutiveObject.stateNames !== null
									? salesExecutiveObject.stateNames
									: "-",
							zoneNames:
								salesExecutiveObject.zoneNames !== null
									? salesExecutiveObject.zoneNames
									: "-",
							areaNames:
								salesExecutiveObject.areaNames !== null
									? salesExecutiveObject.areaNames
									: "",
							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,
							type:
								salesExecutiveObject.type === null
									? ""
									: salesExecutiveObject.type == 0
										? "Value Wise Target"
										: salesExecutiveObject.type == 1
											? "Beat Wise Target"
											: "RU Wise Target",
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesTeamByUserTypeAndHierarchy =
	({ jsonForSave }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url:
					URL +
					"/by-stock-stake-holder-type-and-region-state-zone-dist-taluka-area ",
				postBody: jsonForSave,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							userId:
								salesExecutiveObject.userId === null
									? ""
									: salesExecutiveObject.userId,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.prefix !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.stockStakeHolderType.prefix +
										")"
									: "",
							salesTeamName:
								salesExecutiveObject.name !== null
									? salesExecutiveObject.name
									: "",
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							employeeCode:
								salesExecutiveObject.employeeCode === null
									? ""
									: salesExecutiveObject.employeeCode,
							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							reportingManagerTypeId:
								salesExecutiveObject.reportingManagerTypeId === null
									? ""
									: salesExecutiveObject.reportingManagerTypeId,
							reportingManagerId:
								salesExecutiveObject.reportingManagerId === null
									? ""
									: salesExecutiveObject.reportingManagerId,
							regionId:
								salesExecutiveObject.regionId === null
									? ""
									: salesExecutiveObject.regionId,
							regionId:
								salesExecutiveObject.regionId === null
									? ""
									: salesExecutiveObject.regionId,
							zoneIds:
								salesExecutiveObject.zoneIds === null
									? ""
									: salesExecutiveObject.zoneIds,
							areaIds:
								salesExecutiveObject.areaIds === null
									? ""
									: salesExecutiveObject.areaIds,
							accessRoleId:
								salesExecutiveObject.accessRoleId === null
									? ""
									: salesExecutiveObject.accessRoleId,
							type:
								salesExecutiveObject.type === null
									? ""
									: salesExecutiveObject.type,
							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
							insertDateTime:
								salesExecutiveObject.insertDateTime === null
									? ""
									: salesExecutiveObject.insertDateTime,
							stockStakeHolderTypeId:
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.id !== null
									? salesExecutiveObject.stockStakeHolderType.id
									: "",
							stockStakeHolderPrefix:
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.prefix !== null
									? salesExecutiveObject.stockStakeHolderType.prefix
									: "",
						};
						return salesExecutiveData;
					});

					dispatch(salesTeamByUserTypeAndTalukaSuccess({ row }));
					return { response: row, success };
				}
				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesTeamWithoutConfigurationByArea =
	({ jsonForSave }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/with-beat-count-day-end-ru-config-by-areas",
				postBody: jsonForSave,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data
						.filter((row) => !(row.dayEndClaim == 1 && row.ruConfig == 1))
						.map((salesExecutiveObject, index) => {
							let salesExecutiveData = {
								index: index + 1,
								id:
									salesExecutiveObject.id === null
										? ""
										: salesExecutiveObject.id,
								areaIds:
									salesExecutiveObject.areaIds === null
										? ""
										: salesExecutiveObject.areaIds,
								areaNames:
									salesExecutiveObject.areaNames === null
										? ""
										: salesExecutiveObject.areaNames,
								name:
									salesExecutiveObject.name === null
										? ""
										: salesExecutiveObject.name,
								salesTeamName:
									salesExecutiveObject.name === null
										? ""
										: salesExecutiveObject.name +
											" (" +
											salesExecutiveObject.prefix +
											")",
								beatCount:
									salesExecutiveObject.beatCount === null
										? ""
										: salesExecutiveObject.beatCount,
								dayEndClaim:
									salesExecutiveObject.dayEndClaim === null
										? ""
										: salesExecutiveObject.dayEndClaim,
								dayEndClaimForTable:
									salesExecutiveObject.dayEndClaim === null
										? ""
										: salesExecutiveObject.dayEndClaim == 1
											? "Yes"
											: "No",
								ruConfig:
									salesExecutiveObject.ruConfig === null
										? ""
										: salesExecutiveObject.ruConfig,
								ruConfigForTable:
									salesExecutiveObject.ruConfig === null
										? ""
										: salesExecutiveObject.ruConfig == 1
											? "Yes"
											: "No",
								stockStakeHolderTypeId:
									salesExecutiveObject.stockStakeHolderTypeId === null
										? ""
										: salesExecutiveObject.stockStakeHolderTypeId,
								stockStakeHolderTypeName:
									salesExecutiveObject.stockStakeHolderTypeName === null
										? ""
										: salesExecutiveObject.stockStakeHolderTypeName,
								ruConfigValue:
									salesExecutiveObject.ruConfig === null
										? ""
										: salesExecutiveObject.ruConfig,
								dayEndClaimValue:
									salesExecutiveObject.dayEndClaim === null
										? ""
										: salesExecutiveObject.dayEndClaim,
							};
							return salesExecutiveData;
						});

					dispatch(salesTeamWithoutConfigurationByAreaSuccess({ row }));
					return { response: row, success };
				}
				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const setSalesTeamWithoutConfigurationByArea =
	({ row }) =>
	async (dispatch) => {
		dispatch(salesTeamWithoutConfigurationByAreaSuccess({ row }));
	};

export const getSalesExecutiveByUserAndStockHolderType =
	({ stockStakeHolderId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/by-user-and-stock-stake-holder-type-ids?stockStakeHolderTypeIds=" +
					stockStakeHolderId,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name === null
									? ""
									: salesExecutiveObject.name,
							salesTeamName:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.prefix !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.stockStakeHolderType.prefix +
										")"
									: "",
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							locality:
								salesExecutiveObject.locality === null
									? ""
									: salesExecutiveObject.locality,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							regionName:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.name
									? salesExecutiveObject.region.name
									: "",
							region:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.id
									? salesExecutiveObject.region.id
									: "",
							zoneNames:
								salesExecutiveObject.zoneNames !== null
									? salesExecutiveObject.zoneNames
									: "",
							areaNames:
								salesExecutiveObject.areaNames !== null
									? salesExecutiveObject.areaNames
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesTeamByBelowOrderOfLoginUserByAreas =
	({ areaIds }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/get-below-order-of-login-person-by-areas",
				postBody: areaIds,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.prefix !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.stockStakeHolderType.prefix +
										" )"
									: "",
							stockStakeHolderType:
								salesExecutiveObject.stockStakeHolderType === null
									? ""
									: salesExecutiveObject.stockStakeHolderType,
							stockStakeHolderTypeId:
								salesExecutiveObject.stockStakeHolderType === null
									? ""
									: salesExecutiveObject.stockStakeHolderType.id,
							stockStakeHolderTypeName:
								salesExecutiveObject.stockStakeHolderType === null
									? ""
									: salesExecutiveObject.stockStakeHolderType.name,
							stockStakeHolderTypePrefix:
								salesExecutiveObject.stockStakeHolderType === null
									? ""
									: salesExecutiveObject.stockStakeHolderType.prefix,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,

							region:
								salesExecutiveObject.regionId !== null
									? salesExecutiveObject.regionId
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesTeamByReportingManagerId =
	({ managerId, flag }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/by-reporting-manager-id?reportingManagerId=" +
					managerId +
					"&flag=" +
					flag,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.prefix !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.stockStakeHolderType.prefix +
										" )"
									: "",
							stockStakeHolderType:
								salesExecutiveObject.stockStakeHolderType === null
									? ""
									: salesExecutiveObject.stockStakeHolderType,
							stockStakeHolderTypeId:
								salesExecutiveObject.stockStakeHolderType === null
									? ""
									: salesExecutiveObject.stockStakeHolderType.id,
							stockStakeHolderTypeName:
								salesExecutiveObject.stockStakeHolderType === null
									? ""
									: salesExecutiveObject.stockStakeHolderType.name,
							stockStakeHolderTypePrefix:
								salesExecutiveObject.stockStakeHolderType === null
									? ""
									: salesExecutiveObject.stockStakeHolderType.prefix,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,

							region:
								salesExecutiveObject.regionId !== null
									? salesExecutiveObject.regionId
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getMonthlyClaimStatusBySalesTeam =
	({ monthYear, salesTeamId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/monthly-claim-status-by-sales-team-from-isvisit-mlogs?monthYear=" +
					monthYear +
					"&salesTeamId=" +
					salesTeamId,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name === null
									? ""
									: salesExecutiveObject.name,
							stockStakeHolderTypePrefix:
								salesExecutiveObject.stockStakeHolderTypePrefix === null
									? ""
									: salesExecutiveObject.stockStakeHolderTypePrefix,
							date:
								salesExecutiveObject.date === null
									? ""
									: salesExecutiveObject.date,
							beatWithClaim:
								salesExecutiveObject.beatWithClaim === null
									? ""
									: salesExecutiveObject.beatWithClaim,
							beatNames:
								salesExecutiveObject.beatWithClaim !== null &&
								salesExecutiveObject.beatWithClaim.beatNames !== null
									? salesExecutiveObject.beatWithClaim.beatNames
									: "-",
							flag:
								salesExecutiveObject.flag === null
									? ""
									: salesExecutiveObject.flag,
							claimStatus:
								salesExecutiveObject.claimStatus === null
									? ""
									: salesExecutiveObject.claimStatus,
							stockStakeHolderTypeId:
								salesExecutiveObject.stockStakeHolderTypeId === null
									? ""
									: salesExecutiveObject.stockStakeHolderTypeId,
						};
						return salesExecutiveData;
					});
					dispatch(monthlyClaimStatusSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const setMonthlyClaimStatusBySalesTeam =
	({ row }) =>
	async (dispatch) => {
		dispatch(monthlyClaimStatusSuccess({ row }));
	};

export const getAboveOrderList = () => async (dispatch) => {
	try {
		const response = apiGet({
			url: URL + "/get-above-order-list",
		}).then(({ data, success }) => {
			if (success) {
				const row = data.data.map((salesExecutiveObject, index) => {
					let salesExecutiveData = {
						index: index + 1,
						id: salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
						name:
							salesExecutiveObject.name !== null &&
							salesExecutiveObject.stockStakeHolderType !== null &&
							salesExecutiveObject.stockStakeHolderType.prefix !== null
								? salesExecutiveObject.name +
									" (" +
									salesExecutiveObject.stockStakeHolderType.prefix +
									" )"
								: "",
						stockStakeHolderType:
							salesExecutiveObject.stockStakeHolderType === null
								? ""
								: salesExecutiveObject.stockStakeHolderType,
						stockStakeHolderTypeId:
							salesExecutiveObject.stockStakeHolderType === null
								? ""
								: salesExecutiveObject.stockStakeHolderType.id,
						stockStakeHolderTypeName:
							salesExecutiveObject.stockStakeHolderType === null
								? ""
								: salesExecutiveObject.stockStakeHolderType.name,
						stockStakeHolderTypePrefix:
							salesExecutiveObject.stockStakeHolderType === null
								? ""
								: salesExecutiveObject.stockStakeHolderType.prefix,
						userName:
							salesExecutiveObject.userName === null
								? ""
								: salesExecutiveObject.userName,
						address:
							salesExecutiveObject.address === null
								? ""
								: salesExecutiveObject.address,

						region:
							salesExecutiveObject.regionId !== null
								? salesExecutiveObject.regionId
								: "",

						emailId:
							salesExecutiveObject.emailId === null
								? ""
								: salesExecutiveObject.emailId,
						contactNo:
							salesExecutiveObject.contactNo === null
								? ""
								: salesExecutiveObject.contactNo,
						whatsAppNo:
							salesExecutiveObject.whatsAppNo === null
								? ""
								: salesExecutiveObject.whatsAppNo,

						isActive:
							salesExecutiveObject.isActive === null
								? ""
								: salesExecutiveObject.isActive,
					};
					return salesExecutiveData;
				});
				dispatch(salesExecutiveSuccess({ row }));
				return { response: row, success };
			}
			return { response: [], success };
		});
		return response;
	} catch (e) {
		return console.error(e.message);
	}
};

export const getReportingAuthorityBySalesTeam =
	({ salesTeamId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/get-reporting-authority-of-sales-team?salesTeamId=" +
					salesTeamId,
			}).then(({ data, success }) => {
				if (success) {
					let salesExecutiveObject = data.data;
					let salesExecutiveData = {
						id: salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
						name:
							salesExecutiveObject.name !== null &&
							salesExecutiveObject.stockStakeHolderType !== null &&
							salesExecutiveObject.stockStakeHolderType.prefix !== null
								? salesExecutiveObject.name +
									" (" +
									salesExecutiveObject.stockStakeHolderType.prefix +
									" )"
								: "",
						stockStakeHolderType:
							salesExecutiveObject.stockStakeHolderType === null
								? ""
								: salesExecutiveObject.stockStakeHolderType,
						stockStakeHolderTypeId:
							salesExecutiveObject.stockStakeHolderType === null
								? ""
								: salesExecutiveObject.stockStakeHolderType.id,
						stockStakeHolderTypeName:
							salesExecutiveObject.stockStakeHolderType === null
								? ""
								: salesExecutiveObject.stockStakeHolderType.name,
						stockStakeHolderTypePrefix:
							salesExecutiveObject.stockStakeHolderType === null
								? ""
								: salesExecutiveObject.stockStakeHolderType.prefix,
						userName:
							salesExecutiveObject.userName === null
								? ""
								: salesExecutiveObject.userName,
					};

					dispatch(reportingAuthoritySuccess({ row: salesExecutiveData }));
					return { response: salesExecutiveData, success };
				}
				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getUnderSalesTeamList = () => async (dispatch) => {
	try {
		const response = apiGet({
			url: URL + "/get-under-sales-team-list-for-login-person",
		}).then(({ data, success }) => {
			if (success) {
				const row = data.data.map((salesExecutiveObject, index) => {
					let salesExecutiveData = {
						index: index + 1,
						id: salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
						name:
							salesExecutiveObject.name !== null &&
							salesExecutiveObject.stockStakeHolderTypePrefix !== null
								? salesExecutiveObject.name +
									" (" +
									salesExecutiveObject.stockStakeHolderTypePrefix +
									")"
								: "",
						// stockStakeHolderType:
						//   salesExecutiveObject.stockStakeHolderType === null
						//     ? ""
						//     : salesExecutiveObject.stockStakeHolderType,
						// stockStakeHolderTypeId:
						//   salesExecutiveObject.stockStakeHolderType === null
						//     ? ""
						//     : salesExecutiveObject.stockStakeHolderType.id,
						// stockStakeHolderTypeName:
						//   salesExecutiveObject.stockStakeHolderType === null
						//     ? ""
						//     : salesExecutiveObject.stockStakeHolderType.name,
						stockStakeHolderTypePrefix:
							salesExecutiveObject.stockStakeHolderTypePrefix === null
								? ""
								: salesExecutiveObject.stockStakeHolderTypePrefix,
						userName:
							salesExecutiveObject.userName === null
								? ""
								: salesExecutiveObject.userName,
						address:
							salesExecutiveObject.address === null
								? ""
								: salesExecutiveObject.address,

						region:
							salesExecutiveObject.regionId !== null
								? salesExecutiveObject.regionId
								: "",

						emailId:
							salesExecutiveObject.emailId === null
								? ""
								: salesExecutiveObject.emailId,
						contactNo:
							salesExecutiveObject.contactNo === null
								? ""
								: salesExecutiveObject.contactNo,
						whatsAppNo:
							salesExecutiveObject.whatsAppNo === null
								? ""
								: salesExecutiveObject.whatsAppNo,

						isActive:
							salesExecutiveObject.isActive === null
								? ""
								: salesExecutiveObject.isActive,
					};
					return salesExecutiveData;
				});
				dispatch(salesExecutiveSuccess({ row }));
				return { response: row, success };
			}
			return { response: [], success };
		});
		return response;
	} catch (e) {
		return console.error(e.message);
	}
};

export const getBelowSalesTeamList =
	({ salesTeamId, flag }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/below-sales-team-with-reporting-ids?salesTeamId=" +
					salesTeamId +
					"&flag=" +
					flag,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderTypePrefix !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.stockStakeHolderTypePrefix +
										")"
									: "",
							stockStakeHolderTypeId:
								salesExecutiveObject.stockStakeHolderTypeId === null
									? ""
									: salesExecutiveObject.stockStakeHolderTypeId,
							stockStakeHolderTypeName:
								salesExecutiveObject.stockStakeHolderTypeName === null
									? ""
									: salesExecutiveObject.stockStakeHolderTypeName,
							stockStakeHolderTypePrefix:
								salesExecutiveObject.stockStakeHolderTypePrefix === null
									? ""
									: salesExecutiveObject.stockStakeHolderTypePrefix,
							reportingManagerId:
								salesExecutiveObject.reportingManagerId === null
									? ""
									: salesExecutiveObject.reportingManagerId,
							reportingManagerName:
								salesExecutiveObject.reportingManagerName === null
									? ""
									: salesExecutiveObject.reportingManagerName,
							reportingManagerTypeId:
								salesExecutiveObject.reportingManagerTypeId === null
									? ""
									: salesExecutiveObject.reportingManagerTypeId,
							reportingManagerTypeName:
								salesExecutiveObject.reportingManagerTypeName === null
									? ""
									: salesExecutiveObject.reportingManagerTypeName,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,

							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveBelowTeamSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesExecutiveAnalytics =
	({ fromDate, toDate, salesTeamId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/wise-analytics?fromDate=" +
					fromDate +
					"&toDate=" +
					toDate +
					"&salesTeamId=" +
					salesTeamId,
			}).then(({ data, success }) => {
				if (success) {
					let salesExecutiveObjectNew = data.data;
					let salesExecutiveObj = {
						checkInCount:
							salesExecutiveObjectNew.checkInCount !== null
								? salesExecutiveObjectNew.checkInCount
								: "",

						totalVisiteOutletCount:
							salesExecutiveObjectNew.totalVisiteOutletCount !== null
								? salesExecutiveObjectNew.totalVisiteOutletCount
								: "",

						productiveCount:
							salesExecutiveObjectNew.productiveCount !== null
								? salesExecutiveObjectNew.productiveCount
								: "",

						orderAmt:
							salesExecutiveObjectNew.orderAmt !== null
								? salesExecutiveObjectNew.orderAmt
								: "",

						taDaAmt:
							salesExecutiveObjectNew.taDaAmt !== null
								? salesExecutiveObjectNew.taDaAmt
								: "",

						targetAndAchievement:
							salesExecutiveObjectNew.targetAndAchievement !== null
								? salesExecutiveObjectNew.targetAndAchievement
								: "",

						Target:
							salesExecutiveObjectNew.targetAndAchievement !== null &&
							salesExecutiveObjectNew.targetAndAchievement.target !== null
								? salesExecutiveObjectNew.targetAndAchievement.target
								: "",

						Achievement:
							salesExecutiveObjectNew.targetAndAchievement !== null &&
							salesExecutiveObjectNew.targetAndAchievement.achievement !== null
								? salesExecutiveObjectNew.targetAndAchievement.achievement
								: "",

						projectionDates:
							salesExecutiveObjectNew.projectDetail !== null
								? salesExecutiveObjectNew.projectDetail.projectionDates.map(
										(projectionDateObj, index) => {
											let projectionDateData = {
												index: index + 1,
												ids:
													projectionDateObj.ids !== null
														? projectionDateObj.ids
														: "",
												dates:
													projectionDateObj.dates !== null
														? projectionDateObj.dates
														: "",
												weekDay:
													projectionDateObj.weekDay !== null
														? projectionDateObj.weekDay
														: "",
											};
											return projectionDateData;
										},
									)
								: {},

						projectionPersons:
							salesExecutiveObjectNew.projectDetail !== null
								? salesExecutiveObjectNew.projectDetail.projectionPersons.map(
										(projectionPersonObj, index) => {
											let projectionPersonData = {
												index: index + 1,
												id:
													projectionPersonObj.id !== null
														? projectionPersonObj.id
														: "",
												salesTeamId:
													projectionPersonObj.salesTeam !== null &&
													projectionPersonObj.salesTeam.id !== null
														? projectionPersonObj.salesTeam.id
														: "",
												salesTeamName:
													projectionPersonObj.salesTeam !== null &&
													projectionPersonObj.salesTeam.name !== null
														? projectionPersonObj.salesTeam.name
														: "",
												salesTeamStockHolderTypeId:
													projectionPersonObj.salesTeam !== null &&
													projectionPersonObj.salesTeam.stockStakeHolderType !==
														null &&
													projectionPersonObj.salesTeam.stockStakeHolderType
														.id !== null
														? projectionPersonObj.salesTeam.stockStakeHolderType
																.id
														: "",
												salesTeamStockHolderTypePrefix:
													projectionPersonObj.salesTeam !== null &&
													projectionPersonObj.salesTeam.stockStakeHolderType !==
														null &&
													projectionPersonObj.salesTeam.stockStakeHolderType
														.prefix !== null
														? projectionPersonObj.salesTeam.stockStakeHolderType
																.prefix
														: "",
												date:
													projectionPersonObj.date !== null
														? projectionPersonObj.date
														: "",
												weekDay:
													projectionPersonObj.weekDay !== null
														? projectionPersonObj.weekDay
														: "",
												beatIds:
													projectionPersonObj.beatIds !== null
														? projectionPersonObj.beatIds
														: "",
												beatNames:
													projectionPersonObj.beatNames !== null
														? projectionPersonObj.beatNames
														: "",
												flag:
													projectionPersonObj.flag !== null
														? projectionPersonObj.flag
														: "",
												beatWithOutletCounts:
													projectionPersonObj.beatWithOutletCounts !== null
														? projectionPersonObj.beatWithOutletCounts
														: "",
											};
											return projectionPersonData;
										},
									)
								: {},

						projectionPersonAndDateList:
							salesExecutiveObjectNew.projectDetail !== null
								? salesExecutiveObjectNew.projectDetail.projectionPersonAndDateList.map(
										(projectionDateListObj, index) => {
											let projectionDateListData = {
												index: index + 1,
												id:
													projectionDateListObj.id !== null
														? projectionDateListObj.id
														: "",
												salesTeamId:
													projectionDateListObj.salesTeam !== null &&
													projectionDateListObj.salesTeam.id !== null
														? projectionDateListObj.salesTeam.id
														: "",
												salesTeamName:
													projectionDateListObj.salesTeam !== null &&
													projectionDateListObj.salesTeam.name !== null
														? projectionDateListObj.salesTeam.name
														: "",
												salesTeamStockHolderTypeId:
													projectionDateListObj.salesTeam !== null &&
													projectionDateListObj.salesTeam
														.stockStakeHolderType !== null &&
													projectionDateListObj.salesTeam.stockStakeHolderType
														.id !== null
														? projectionDateListObj.salesTeam
																.stockStakeHolderType.id
														: "",
												salesTeamStockHolderTypePrefix:
													projectionDateListObj.salesTeam !== null &&
													projectionDateListObj.salesTeam
														.stockStakeHolderType !== null &&
													projectionDateListObj.salesTeam.stockStakeHolderType
														.prefix !== null
														? projectionDateListObj.salesTeam
																.stockStakeHolderType.prefix
														: "",
												date:
													projectionDateListObj.date !== null
														? projectionDateListObj.date
														: "",
												weekDay:
													projectionDateListObj.weekDay !== null
														? projectionDateListObj.weekDay
														: "",
												beatIds:
													projectionDateListObj.beatIds !== null
														? projectionDateListObj.beatIds
														: "",
												beatNames:
													projectionDateListObj.beatNames !== null
														? projectionDateListObj.beatNames
														: "",
												flag:
													projectionDateListObj.flag !== null
														? projectionDateListObj.flag
														: "",
												beatWithOutletCounts:
													projectionDateListObj.beatWithOutletCounts !== null
														? projectionDateListObj.beatWithOutletCounts
														: "",
											};
											return projectionDateListData;
										},
									)
								: {},

						beatAssign:
							salesExecutiveObjectNew.beatAssign !== null
								? salesExecutiveObjectNew.beatAssign.map(
										(beatAssignObj, index) => {
											let beatAssignData = {
												index: index + 1,
												id: beatAssignObj.id !== null ? beatAssignObj.id : "",
												beatName:
													beatAssignObj.beatName !== null
														? beatAssignObj.beatName
														: "",
												areaId:
													beatAssignObj.areaId !== null
														? beatAssignObj.areaId
														: "",
												areaName:
													beatAssignObj.areaName !== null
														? beatAssignObj.areaName
														: "",
												outletCount:
													beatAssignObj.outletCount !== null
														? beatAssignObj.outletCount
														: "",
												days:
													beatAssignObj.days !== null ? beatAssignObj.days : "",
											};
											return beatAssignData;
										},
									)
								: [],

						timeLine:
							salesExecutiveObjectNew.timeLine !== null
								? salesExecutiveObjectNew.timeLine.map((timeLineObj, index) => {
										let timeLineData = {
											index: index + 1,
											id: timeLineObj.id !== null ? timeLineObj.id : "",
											date: timeLineObj.date !== null ? timeLineObj.date : "",
											orderAmt:
												timeLineObj.orderAmt !== null
													? timeLineObj.orderAmt
													: "",
											billAmt:
												timeLineObj.billAmt !== null ? timeLineObj.billAmt : "",
										};
										return timeLineData;
									})
								: [],

						dayWiseBeatAssign:
							salesExecutiveObjectNew.dayWiseBeatAssign !== null
								? salesExecutiveObjectNew.dayWiseBeatAssign.map(
										(dayWiseBeatAssignObj, index) => {
											let dayWiseBeatAssignData = {
												index: index + 1,
												id:
													dayWiseBeatAssignObj.id !== null
														? dayWiseBeatAssignObj.id
														: "",
												days:
													dayWiseBeatAssignObj.days !== null
														? dayWiseBeatAssignObj.days
														: "",
												beatName:
													dayWiseBeatAssignObj.beatName !== null
														? dayWiseBeatAssignObj.beatName
														: "",
												areaId:
													dayWiseBeatAssignObj.areaId !== null
														? dayWiseBeatAssignObj.areaId
														: "",
												areaName:
													dayWiseBeatAssignObj.areaName !== null
														? dayWiseBeatAssignObj.areaName
														: "",
												outletCount:
													dayWiseBeatAssignObj.outletCount !== null
														? dayWiseBeatAssignObj.outletCount
														: "",
											};
											return dayWiseBeatAssignData;
										},
									)
								: [],

						feedBackList:
							salesExecutiveObjectNew.feedBackList !== null
								? salesExecutiveObjectNew.feedBackList.map(
										(feedbackListObj, index) => {
											let feedbackListData = {
												index: index + 1,
												id:
													feedbackListObj.id !== null ? feedbackListObj.id : "",
												outletId:
													feedbackListObj.outletId !== null
														? feedbackListObj.outletId
														: "",
												outletName:
													feedbackListObj.outletName !== null
														? feedbackListObj.outletName
														: "",
												grivienceCategoryId:
													feedbackListObj.grivienceCategoryId !== null
														? feedbackListObj.grivienceCategoryId
														: "",
												categoryCame:
													feedbackListObj.categoryCame !== null
														? feedbackListObj.categoryCame
														: "",
												status:
													feedbackListObj.status !== null
														? feedbackListObj.status == 0
															? "Pending"
															: "Completed"
														: "",
												remark:
													feedbackListObj.remark !== null
														? feedbackListObj.remark
														: "",
											};
											return feedbackListData;
										},
									)
								: [],

						auditTransaction:
							salesExecutiveObjectNew.auditTransaction !== null
								? salesExecutiveObjectNew.auditTransaction.map(
										(auditTransactionObj, index) => {
											let auditTransactionData = {
												index: index + 1,
												id:
													auditTransactionObj.id !== null
														? auditTransactionObj.id
														: "",
												date:
													auditTransactionObj.date !== null
														? auditTransactionObj.date
														: "",
												auditHeadId:
													auditTransactionObj.auditHeadId !== null
														? auditTransactionObj.auditHeadId
														: "",
												auditHeadName:
													auditTransactionObj.auditHeadName !== null
														? auditTransactionObj.auditHeadName
														: "",
											};
											return auditTransactionData;
										},
									)
								: [],
					};
					dispatch(salesExecutiveAnalysisSuccess({ row: salesExecutiveObj }));
					return { response: salesExecutiveObj, success };
				}
				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getReportingManagerHierarchy =
	({ dataJson }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/reporting-manager-hierarchy",
				postBody: dataJson,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.prefix !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.stockStakeHolderType.prefix +
										")"
									: "",
							stockStakeHolderType:
								salesExecutiveObject.stockStakeHolderType === null
									? ""
									: salesExecutiveObject.stockStakeHolderType,
							stockStakeHolderTypeId:
								salesExecutiveObject.stockStakeHolderType === null
									? ""
									: salesExecutiveObject.stockStakeHolderType.id,
							stockStakeHolderTypeName:
								salesExecutiveObject.stockStakeHolderType === null
									? ""
									: salesExecutiveObject.stockStakeHolderType.name,
							stockStakeHolderTypePrefix:
								salesExecutiveObject.stockStakeHolderType === null
									? ""
									: salesExecutiveObject.stockStakeHolderType.prefix,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							employeeCode:
								salesExecutiveObject.employeeCode === null
									? ""
									: salesExecutiveObject.employeeCode,
							type:
								salesExecutiveObject.type === null
									? ""
									: salesExecutiveObject.type,
							dmsApplicable:
								salesExecutiveObject.dmsApplicable === null
									? ""
									: salesExecutiveObject.dmsApplicable,
							stockApplicable:
								salesExecutiveObject.stockApplicable === null
									? ""
									: salesExecutiveObject.stockApplicable,
							reportingManagerTypeId:
								salesExecutiveObject.reportingManagerTypeId === null
									? ""
									: salesExecutiveObject.reportingManagerTypeId,
							reportingManagerId:
								salesExecutiveObject.reportingManagerId === null
									? ""
									: salesExecutiveObject.reportingManagerId,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
							isChecked: false,
							beatAssigns:
								salesExecutiveObject.beatAssigns !== null
									? salesExecutiveObject.beatAssigns.map((obj, index) => {
											let beatAssignData = {
												id: obj.id !== null ? obj.id : "",
												beatId:
													obj.beat !== null && obj.beat.id !== null
														? obj.beat.id
														: "",
												beatName:
													obj.beat !== null && obj.beat.beatName !== null
														? obj.beat.beatName
														: "",
												areaName:
													obj.beat !== null && obj.beat.area !== null
														? obj.beat.area.name
														: "",
												distance:
													obj.distanceFromHq !== null ? obj.distanceFromHq : "",
												beatType: obj.beatType !== null ? obj.beatType : "",
												beatSubType:
													obj.beatSubType !== null ? obj.beatSubType : "",
												ratePerKm:
													obj.ratePerKm !== null && obj.beatType !== null
														? obj.beatType == 0
															? 0
															: obj.ratePerKm
														: "",
												dailyAllowance:
													obj.dailyAllowance !== null ? obj.dailyAllowance : "",
												selfAssign:
													obj.selfAssign !== null ? obj.selfAssign : "",
												isActive: obj.isActive !== null ? obj.isActive : "",
												salesTeamId:
													obj.salesTeam !== null && obj.salesTeam.id !== null
														? obj.salesTeam.id
														: "",
												salesTeamName:
													obj.salesTeam !== null &&
													obj.salesTeam.name !== null &&
													obj.salesTeam.stockStakeHolderType !== null &&
													obj.salesTeam.stockStakeHolderType.prefix !== null
														? obj.salesTeam.name +
															" (" +
															obj.salesTeam.stockStakeHolderType.prefix +
															")"
														: "",
												isChecked: false,
											};
											return beatAssignData;
										})
									: [],
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const setReportingManagerHierarchy =
	({ row }) =>
	async (dispatch) => {
		dispatch(salesExecutiveSuccess({ row }));
	};

export const getDriversByArea = () => async (dispatch) => {
	try {
		const response = apiGet({
			url: URL + "/get-drivers-by-areas",
		}).then(({ data, success }) => {
			if (success) {
				const row = data.data.map((salesExecutiveObject, index) => {
					let salesExecutiveData = {
						index: index + 1,
						id: salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
						userName:
							salesExecutiveObject.userName === null
								? ""
								: salesExecutiveObject.userName,
						employeeCode:
							salesExecutiveObject.employeeCode === null ||
							salesExecutiveObject.employeeCode === ""
								? "-"
								: salesExecutiveObject.employeeCode,
						name:
							salesExecutiveObject.name === null
								? ""
								: salesExecutiveObject.name,
						address:
							salesExecutiveObject.address === null
								? ""
								: salesExecutiveObject.address,

						regionName:
							salesExecutiveObject.regionName !== null
								? salesExecutiveObject.regionName
								: "-",

						regionId:
							salesExecutiveObject.regionId !== null
								? salesExecutiveObject.regionId
								: "",
						stateNames:
							salesExecutiveObject.stateNames !== null
								? salesExecutiveObject.stateNames
								: "-",
						zoneNames:
							salesExecutiveObject.zoneNames !== null
								? salesExecutiveObject.zoneNames
								: "-",
						areaNames:
							salesExecutiveObject.areaNames !== null
								? salesExecutiveObject.areaNames
								: "",
						emailId:
							salesExecutiveObject.emailId === null
								? ""
								: salesExecutiveObject.emailId,
						isActive:
							salesExecutiveObject.isActive === null
								? ""
								: salesExecutiveObject.isActive,
						contactNo:
							salesExecutiveObject.contactNo === null
								? ""
								: salesExecutiveObject.contactNo,
						whatsAppNo:
							salesExecutiveObject.whatsAppNo === null
								? ""
								: salesExecutiveObject.whatsAppNo,
						type:
							salesExecutiveObject.type === null
								? ""
								: salesExecutiveObject.type == 0
									? "Value Wise Target"
									: salesExecutiveObject.type == 1
										? "Beat Wise Target"
										: "RU Wise Target",
					};
					return salesExecutiveData;
				});
				dispatch(salesExecutiveSuccess({ row }));
				return { response: row, success };
			}
			return { response: [], success };
		});
		return response;
	} catch (e) {
		return console.error(e.message);
	}
};

export const getDriversByAreaId =
	({ areaId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/not-in-beat-assign-vehicle-daywise-header-by-area?areaId=" +
					areaId,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.prefix !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.stockStakeHolderType.prefix +
										")"
									: "",
							salesTeamName:
								salesExecutiveObject.name === null
									? ""
									: salesExecutiveObject.name,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,
							regionName:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.name
									? salesExecutiveObject.region.name
									: "",
							region:
								salesExecutiveObject.region !== null &&
								salesExecutiveObject.region.id
									? salesExecutiveObject.region.id
									: "",
							zoneNames:
								salesExecutiveObject.zoneNames !== null
									? salesExecutiveObject.zoneNames
									: "",
							areaNames:
								salesExecutiveObject.areaNames !== null
									? salesExecutiveObject.areaNames
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getDriversByStockHolderId =
	({ stockHolderId, areaIdJson }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url:
					URL +
					"/by-stock-stake-holder-or-area?stockStakeHolderIds=" +
					stockHolderId,
				postBody: areaIdJson,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderType !== null &&
								salesExecutiveObject.stockStakeHolderType.prefix !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.stockStakeHolderType.prefix +
										")"
									: "",
							salesTeamName:
								salesExecutiveObject.name === null
									? ""
									: salesExecutiveObject.name,
							address:
								salesExecutiveObject.address === null
									? ""
									: salesExecutiveObject.address,

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							whatsAppNo:
								salesExecutiveObject.whatsAppNo === null
									? ""
									: salesExecutiveObject.whatsAppNo,

							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesExecutiveData;
					});
					dispatch(driverByStockHolderSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getBelowSalesTeamBasicInfo =
	({ salesTeamId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/get-below-sales-team-basic-info?salesTeamId=" +
					salesTeamId +
					"&flag=1",
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesTeamObject, index) => {
						let salesTeamData = {
							index: index + 1,
							id: salesTeamObject.id === null ? "" : salesTeamObject.id,
							name: salesTeamObject.name === null ? "" : salesTeamObject.name,
							userName:
								salesTeamObject.userName === null
									? ""
									: salesTeamObject.userName,
							employeeCode:
								salesTeamObject.employeeCode === null
									? ""
									: salesTeamObject.employeeCode,
							whatsAppNo:
								salesTeamObject.whatsAppNo === null
									? ""
									: salesTeamObject.whatsAppNo,
							contactNo:
								salesTeamObject.contactNo === null
									? ""
									: salesTeamObject.contactNo,
							stockStakeHolderTypeName:
								salesTeamObject.stockStakeHolderTypeName === null
									? ""
									: salesTeamObject.stockStakeHolderTypeName,
							stockStakeHolderTypeName:
								salesTeamObject.stockStakeHolderTypeName === null
									? ""
									: salesTeamObject.stockStakeHolderTypeName,
							stockStakeHolderTypePrefix:
								salesTeamObject.stockStakeHolderTypePrefix === null
									? ""
									: salesTeamObject.stockStakeHolderTypePrefix,
							userTypeId:
								salesTeamObject.userTypeId === null
									? ""
									: salesTeamObject.userTypeId,
							sortOrder:
								salesTeamObject.sortOrder === null
									? ""
									: salesTeamObject.sortOrder,
							outletEdit:
								salesTeamObject.outletEdit === null
									? ""
									: salesTeamObject.outletEdit,
							sequenceWiseOrder:
								salesTeamObject.sequenceWiseOrder === null
									? ""
									: salesTeamObject.sequenceWiseOrder,
							isActive:
								salesTeamObject.isActive === null
									? ""
									: salesTeamObject.isActive,
						};
						return salesTeamData;
					});
					dispatch(salesTeamConfigurationSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const setTeamList =
	({ row }) =>
	async (dispatch) => {
		dispatch(salesTeamConfigurationSuccess({ row }));
	};

export const getSalesTeamBasicInfoByAreas =
	({ dataJson }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/get-sales-team-basic-info-by-areas",
				postBody: dataJson,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesTeamAreaObject, index) => {
						let salesTeamData = {
							index: index + 1,
							id: salesTeamAreaObject.id === null ? "" : salesTeamAreaObject.id,
							userName:
								salesTeamAreaObject.userName === null
									? ""
									: salesTeamAreaObject.userName,
							name:
								salesTeamAreaObject.name === null
									? ""
									: salesTeamAreaObject.name,
							employeeCode:
								salesTeamAreaObject.employeeCode === null
									? ""
									: salesTeamAreaObject.employeeCode,
							whatsAppNo:
								salesTeamAreaObject.whatsAppNo === null
									? ""
									: salesTeamAreaObject.whatsAppNo,
							contactNo:
								salesTeamAreaObject.contactNo === null
									? ""
									: salesTeamAreaObject.contactNo,
							stockStakeHolderTypeName:
								salesTeamAreaObject.stockStakeHolderTypeName === null
									? ""
									: salesTeamAreaObject.stockStakeHolderTypeName,
							stockStakeHolderTypeName:
								salesTeamAreaObject.stockStakeHolderTypeName === null
									? ""
									: salesTeamAreaObject.stockStakeHolderTypeName,
							stockStakeHolderTypePrefix:
								salesTeamAreaObject.stockStakeHolderTypePrefix === null
									? ""
									: salesTeamAreaObject.stockStakeHolderTypePrefix,
							userTypeId:
								salesTeamAreaObject.userTypeId === null
									? ""
									: salesTeamAreaObject.userTypeId,
							sortOrder:
								salesTeamAreaObject.sortOrder === null
									? ""
									: salesTeamAreaObject.sortOrder,
							outletEdit:
								salesTeamAreaObject.outletEdit === null
									? ""
									: salesTeamAreaObject.outletEdit,
							sequenceWiseOrder:
								salesTeamAreaObject.sequenceWiseOrder === null
									? ""
									: salesTeamAreaObject.sequenceWiseOrder,
							isActive:
								salesTeamAreaObject.isActive === null
									? ""
									: salesTeamAreaObject.isActive,
						};
						return salesTeamData;
					});
					dispatch(salesTeamConfigurationSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const setSalesTeamWithAreaNames =
	({ row }) =>
	async (dispatch) => {
		dispatch(
			salesPersonByAreaAndStockHolderTypeForClaimStructureSuccess({ row }),
		);
	};

export const getSalesTeamWithAreaNames =
	({ claimStructureHeaderId, salesTeamId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/by-sales-team-with-area-names-for-claim?claimStructureHeaderId=" +
					claimStructureHeaderId +
					"&salesTeamId=" +
					salesTeamId,
			}).then(({ data, success }) => {
				if (success) {
					if (success) {
						const row = data.data.map((salesExecutiveObject, index) => {
							let salesExecutiveData = {
								index: index + 1,
								id:
									salesExecutiveObject.id === null
										? ""
										: salesExecutiveObject.id,
								employeeCode:
									salesExecutiveObject.employeeCode === null
										? ""
										: salesExecutiveObject.employeeCode,
								name:
									salesExecutiveObject.name === null
										? ""
										: salesExecutiveObject.name,
								stockStakeHolderTypeName:
									salesExecutiveObject.stockStakeHolderTypeName === null
										? ""
										: salesExecutiveObject.stockStakeHolderTypeName,
								reportingManagerName:
									salesExecutiveObject.reportingManagerName === null
										? ""
										: salesExecutiveObject.reportingManagerName,
								reportingManagerTypeName:
									salesExecutiveObject.reportingManagerTypeName === null
										? ""
										: salesExecutiveObject.reportingManagerTypeName,
								areaNames:
									salesExecutiveObject.areaNames !== null
										? salesExecutiveObject.areaNames
										: "",
								userName:
									salesExecutiveObject.userName === null
										? ""
										: salesExecutiveObject.userName,

								whatsAppNo:
									salesExecutiveObject.whatsAppNo !== null
										? salesExecutiveObject.whatsAppNo
										: "",
								contactNo:
									salesExecutiveObject.contactNo !== null
										? salesExecutiveObject.contactNo
										: "",

								address:
									salesExecutiveObject.address !== null
										? salesExecutiveObject.address
										: "",

								employeeCode:
									salesExecutiveObject.employeeCode !== null
										? salesExecutiveObject.employeeCode
										: "",

								emailId:
									salesExecutiveObject.emailId === null
										? ""
										: salesExecutiveObject.emailId,
								contactNo:
									salesExecutiveObject.contactNo === null
										? ""
										: salesExecutiveObject.contactNo,
								regionName:
									salesExecutiveObject.regionName === null
										? ""
										: salesExecutiveObject.regionName,
								type:
									salesExecutiveObject.type === null
										? ""
										: salesExecutiveObject.type,
								insertDateTime:
									salesExecutiveObject.insertDateTime === null
										? ""
										: salesExecutiveObject.insertDateTime,
								isActive:
									salesExecutiveObject.isActive === null
										? ""
										: salesExecutiveObject.isActive,
							};
							return salesExecutiveData;
						});
						dispatch(
							salesPersonByAreaAndStockHolderTypeForClaimStructureSuccess({
								row,
							}),
						);
						return { response: row, success };
					}
				}
				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesTeamWithAreaNamesForClaim =
	({ dataJson }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/by-sales-team-and-types-with-area-names-for-claim",
				postBody: dataJson,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesTeamData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							employeeCode:
								salesExecutiveObject.employeeCode === null
									? ""
									: salesExecutiveObject.employeeCode,
							name:
								salesExecutiveObject.name === null
									? ""
									: salesExecutiveObject.name,
							stockStakeHolderTypeName:
								salesExecutiveObject.stockStakeHolderTypeName === null
									? ""
									: salesExecutiveObject.stockStakeHolderTypeName,
							reportingManagerName:
								salesExecutiveObject.reportingManagerName === null
									? ""
									: salesExecutiveObject.reportingManagerName,
							reportingManagerTypeName:
								salesExecutiveObject.reportingManagerTypeName === null
									? ""
									: salesExecutiveObject.reportingManagerTypeName,
							areaNames:
								salesExecutiveObject.areaNames !== null
									? salesExecutiveObject.areaNames
									: "",
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,

							whatsAppNo:
								salesExecutiveObject.whatsAppNo !== null
									? salesExecutiveObject.whatsAppNo
									: "",
							contactNo:
								salesExecutiveObject.contactNo !== null
									? salesExecutiveObject.contactNo
									: "",

							address:
								salesExecutiveObject.address !== null
									? salesExecutiveObject.address
									: "",

							employeeCode:
								salesExecutiveObject.employeeCode !== null
									? salesExecutiveObject.employeeCode
									: "",

							emailId:
								salesExecutiveObject.emailId === null
									? ""
									: salesExecutiveObject.emailId,
							contactNo:
								salesExecutiveObject.contactNo === null
									? ""
									: salesExecutiveObject.contactNo,
							regionName:
								salesExecutiveObject.regionName === null
									? ""
									: salesExecutiveObject.regionName,
							type:
								salesExecutiveObject.type === null
									? ""
									: salesExecutiveObject.type,
							insertDateTime:
								salesExecutiveObject.insertDateTime === null
									? ""
									: salesExecutiveObject.insertDateTime,
							isActive:
								salesExecutiveObject.isActive === null
									? ""
									: salesExecutiveObject.isActive,
						};
						return salesTeamData;
					});
					dispatch(
						salesPersonByAreaAndStockHolderTypeForClaimStructureSuccess({
							row,
						}),
					);
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};
export const getReportingAuthorityBySalesTeamNew =
	({ salesTeamId, flag }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/get-authority-of-sales-team?salesTeamId=" +
					salesTeamId +
					"&flag=" +
					flag,
			}).then(({ data, success }) => {
				if (success) {
					const salesObj = data.data;
					console.log(salesObj);
					const salesTeamData = {
						id: salesObj.id === null ? "" : salesObj.id,
						name:
							salesObj.name != null
								? salesObj.name +
									(salesObj.stockStakeHolderType !== null &&
									salesObj.stockStakeHolderType.prefix !== null
										? " (" + salesObj.stockStakeHolderType.prefix + ")"
										: "")
								: "",
						userName: salesObj.userName === null ? "" : salesObj.userName,
						stockStakeHolderTypeName:
							salesObj.stockStakeHolderType !== null &&
							salesObj.stockStakeHolderType.name !== null
								? ""
								: salesObj.stockStakeHolderType.name,
					};
					dispatch(salesExecutiveSuccess({ salesTeamData }));
					return { response: salesTeamData, success };
				}
				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getAuthorityWiseUnderSalesTeam =
	({ flag }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/get-authority-wise-under-sales-team-list-for-login-person?flag=" +
					flag,
			}).then(({ data, success }) => {
				if (success) {
					if (success) {
						const row = data.data.map((salesExecutiveObject, index) => {
							let salesExecutiveData = {
								index: index + 1,
								id:
									salesExecutiveObject.id === null
										? ""
										: salesExecutiveObject.id,

								name:
									salesExecutiveObject.name != null
										? salesExecutiveObject.name +
											(salesExecutiveObject.stockStakeHolderTypePrefix !== null
												? " (" +
													salesExecutiveObject.stockStakeHolderTypePrefix +
													")"
												: "")
										: "",
								stockStakeHolderTypeName:
									salesExecutiveObject.stockStakeHolderTypeName === null
										? ""
										: salesExecutiveObject.stockStakeHolderTypeName,
								stockStakeHolderTypePrefix:
									salesExecutiveObject.stockStakeHolderTypePrefix === null
										? ""
										: salesExecutiveObject.stockStakeHolderTypePrefix,
								userName:
									salesExecutiveObject.userName === null
										? ""
										: salesExecutiveObject.userName,

								whatsAppNo:
									salesExecutiveObject.whatsAppNo !== null
										? salesExecutiveObject.whatsAppNo
										: "",

								address:
									salesExecutiveObject.address !== null
										? salesExecutiveObject.address
										: "",

								employeeCode:
									salesExecutiveObject.employeeCode !== null
										? salesExecutiveObject.employeeCode
										: "",

								emailId:
									salesExecutiveObject.emailId === null
										? ""
										: salesExecutiveObject.emailId,
								contactNo:
									salesExecutiveObject.contactNo === null
										? ""
										: salesExecutiveObject.contactNo,
								regionName:
									salesExecutiveObject.regionName === null
										? ""
										: salesExecutiveObject.regionName,
								type:
									salesExecutiveObject.type === null
										? ""
										: salesExecutiveObject.type,
								insertDateTime:
									salesExecutiveObject.insertDateTime === null
										? ""
										: salesExecutiveObject.insertDateTime,
								isActive:
									salesExecutiveObject.isActive === null
										? ""
										: salesExecutiveObject.isActive,
							};
							return salesExecutiveData;
						});
						dispatch(
							salesExecutiveSuccess({
								row,
							}),
						);
						return { response: row, success };
					}
				}
				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesTeamByTypeForClaimStructureAssignation =
	({ dataJson }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/by-types-for-claim-structure-assignation",
				postBody: dataJson,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesTeamObjectNew, index) => {
						let salesTeamData = {
							index: index + 1,
							id: salesTeamObjectNew.id === null ? "" : salesTeamObjectNew.id,
							employeeCode:
								salesTeamObjectNew.employeeCode === null
									? ""
									: salesTeamObjectNew.employeeCode,
							name:
								salesTeamObjectNew.name === null ? "" : salesTeamObjectNew.name,
							stockStakeHolderTypeName:
								salesTeamObjectNew.stockStakeHolderTypeName === null
									? ""
									: salesTeamObjectNew.stockStakeHolderTypeName,
							reportingManagerName:
								salesTeamObjectNew.reportingManagerName === null
									? ""
									: salesTeamObjectNew.reportingManagerName,
							reportingManagerTypeName:
								salesTeamObjectNew.reportingManagerTypeName === null
									? ""
									: salesTeamObjectNew.reportingManagerTypeName,
							userName:
								salesTeamObjectNew.userName === null
									? ""
									: salesTeamObjectNew.userName,

							whatsAppNo:
								salesTeamObjectNew.whatsAppNo !== null
									? salesTeamObjectNew.whatsAppNo
									: "",
							contactNo:
								salesTeamObjectNew.contactNo !== null
									? salesTeamObjectNew.contactNo
									: "",

							address:
								salesTeamObjectNew.address !== null
									? salesTeamObjectNew.address
									: "",

							employeeCode:
								salesTeamObjectNew.employeeCode !== null
									? salesTeamObjectNew.employeeCode
									: "",

							emailId:
								salesTeamObjectNew.emailId === null
									? ""
									: salesTeamObjectNew.emailId,
							contactNo:
								salesTeamObjectNew.contactNo === null
									? ""
									: salesTeamObjectNew.contactNo,

							type:
								salesTeamObjectNew.type === null ? "" : salesTeamObjectNew.type,
							insertDateTime:
								salesTeamObjectNew.insertDateTime === null
									? ""
									: salesTeamObjectNew.insertDateTime,
							isActive:
								salesTeamObjectNew.isActive === null
									? ""
									: salesTeamObjectNew.isActive,
						};
						return salesTeamData;
					});
					dispatch(
						salesPersonByAreaAndStockHolderTypeForClaimStructureSuccess({
							row,
						}),
					);
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesExecutiveForWeeklyOff = () => async (dispatch) => {
	try {
		const response = apiGet({
			url: URL + "/get-below-or-all-for-weekly-off",
		}).then(({ data, success }) => {
			if (success) {
				const row = data.data.map((salesExecutiveObject, index) => {
					let salesExecutiveData = {
						index: index + 1,
						id: salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
						name:
							salesExecutiveObject.name !== null &&
							salesExecutiveObject.stockStakeHolderType !== null &&
							salesExecutiveObject.stockStakeHolderType.prefix !== null
								? salesExecutiveObject.name +
									" (" +
									salesExecutiveObject.stockStakeHolderType.prefix +
									")"
								: "",
						salesTeamName:
							salesExecutiveObject.name === null
								? ""
								: salesExecutiveObject.name,

						emailId:
							salesExecutiveObject.emailId === null
								? ""
								: salesExecutiveObject.emailId,
						contactNo:
							salesExecutiveObject.contactNo === null
								? ""
								: salesExecutiveObject.contactNo,
						whatsAppNo:
							salesExecutiveObject.whatsAppNo === null
								? ""
								: salesExecutiveObject.whatsAppNo,

						isActive:
							salesExecutiveObject.isActive === null
								? ""
								: salesExecutiveObject.isActive,
					};
					return salesExecutiveData;
				});
				dispatch(salesExecutiveSuccess({ row }));
				return { response: row, success };
			}
			return { response: [], success };
		});
		return response;
	} catch (e) {
		return console.error(e.message);
	}
};

export const getActiveSalesTeam =
	({ orderApprovalAuthorityId, flag }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/get-active-for-approval-authority-config?orderApprovalAuthorityId=" +
					orderApprovalAuthorityId +
					"&flag=" +
					flag,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderTypePrefix !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.stockStakeHolderTypePrefix +
										")"
									: "",
							employeeCode:
								salesExecutiveObject.employeeCode === null
									? ""
									: salesExecutiveObject.employeeCode,
							stockStakeHolderTypeId:
								salesExecutiveObject.stockStakeHolderTypeId === null
									? ""
									: salesExecutiveObject.stockStakeHolderTypeId,
							stockStakeHolderTypeName:
								salesExecutiveObject.stockStakeHolderTypeName === null
									? ""
									: salesExecutiveObject.stockStakeHolderTypeName,
							stockStakeHolderTypePrefix:
								salesExecutiveObject.stockStakeHolderTypePrefix === null
									? ""
									: salesExecutiveObject.stockStakeHolderTypePrefix,
							userId:
								salesExecutiveObject.userId === null
									? ""
									: salesExecutiveObject.userId,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							userTypeId:
								salesExecutiveObject.userTypeId === null
									? ""
									: salesExecutiveObject.userTypeId,
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getActiveSalesTeamOfAboveType =
	({ salesTeamId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/above-type-of-given-sales-team?salesTeamId=" + salesTeamId,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id === null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderTypePrefix !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.stockStakeHolderTypePrefix +
										")"
									: "",
							employeeCode:
								salesExecutiveObject.employeeCode === null
									? ""
									: salesExecutiveObject.employeeCode,
							stockStakeHolderTypeId:
								salesExecutiveObject.stockStakeHolderTypeId === null
									? ""
									: salesExecutiveObject.stockStakeHolderTypeId,
							stockStakeHolderTypeName:
								salesExecutiveObject.stockStakeHolderTypeName === null
									? ""
									: salesExecutiveObject.stockStakeHolderTypeName,
							stockStakeHolderTypePrefix:
								salesExecutiveObject.stockStakeHolderTypePrefix === null
									? ""
									: salesExecutiveObject.stockStakeHolderTypePrefix,
							userId:
								salesExecutiveObject.userId === null
									? ""
									: salesExecutiveObject.userId,
							userName:
								salesExecutiveObject.userName === null
									? ""
									: salesExecutiveObject.userName,
							userTypeId:
								salesExecutiveObject.userTypeId === null
									? ""
									: salesExecutiveObject.userTypeId,
						};
						return salesExecutiveData;
					});
					dispatch(reportingAuthoritySuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getActiveSalesTeamByUserTypeIds =
	({ userTypeIdsData }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/by-user-type-ids-with-reporting-data",
				postBody: userTypeIdsData,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id == null ? "" : salesExecutiveObject.id,
							empCode:
								salesExecutiveObject.employeeCode !== null
									? salesExecutiveObject.employeeCode
									: "",
							salesTeamName:
								salesExecutiveObject.name !== null
									? salesExecutiveObject.name
									: "",
							salesTeamType:
								salesExecutiveObject.stockStakeHolderTypeName !== null
									? salesExecutiveObject.stockStakeHolderTypeName
									: "",
							reportingManagerType:
								salesExecutiveObject.reportingManagerTypeName !== null
									? salesExecutiveObject.reportingManagerTypeName
									: "",
							reportingManagerName:
								salesExecutiveObject.reportingManagerName !== null
									? salesExecutiveObject.reportingManagerName
									: "",
							reportingManagerId:
								salesExecutiveObject.reportingManagerId !== null
									? salesExecutiveObject.reportingManagerId
									: "",
						};
						return salesExecutiveData;
					});
					dispatch(salesPersonSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSummaryOfSalesTeamForCompOff =
	({ fromDate }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/by-user-type-ids-with-reporting-data",
				postBody: userTypeIdsData,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id == null ? "" : salesExecutiveObject.id,
							empCode:
								salesExecutiveObject.employeeCode !== null
									? salesExecutiveObject.employeeCode
									: "",
							salesTeamName:
								salesExecutiveObject.name !== null
									? salesExecutiveObject.name
									: "",
							salesTeamType:
								salesExecutiveObject.stockStakeHolderTypeName !== null
									? salesExecutiveObject.stockStakeHolderTypeName
									: "",
							reportingManagerType:
								salesExecutiveObject.reportingManagerTypeName !== null
									? salesExecutiveObject.reportingManagerTypeName
									: "",
							reportingManagerName:
								salesExecutiveObject.reportingManagerName !== null
									? salesExecutiveObject.reportingManagerName
									: "",
							reportingManagerId:
								salesExecutiveObject.reportingManagerId !== null
									? salesExecutiveObject.reportingManagerId
									: "",
						};
						return salesExecutiveData;
					});
					dispatch(salesPersonSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getDaySummaryBySalesTeam =
	({ fromDate, toDate, salesTeamId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/day-summary-by-sales-team-and-date?fromDate=" +
					fromDate +
					"&toDate=" +
					toDate +
					"&salesTeamId=" +
					salesTeamId,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id == null ? "" : salesExecutiveObject.id,
							date:
								salesExecutiveObject.date !== null
									? salesExecutiveObject.date
									: "",
							salesTeamId:
								salesExecutiveObject.salesTeamId !== null
									? salesExecutiveObject.salesTeamId
									: "",
							attendance:
								salesExecutiveObject.attendence !== null
									? salesExecutiveObject.attendence
									: "",
							attendanceForLeave:
								salesExecutiveObject.attendence !== null
									? salesExecutiveObject.attendence
									: "",
							attendanceStatus:
								salesExecutiveObject.attendence !== null
									? salesExecutiveObject.attendence == 0
										? "Present"
										: salesExecutiveObject.attendence == 1
											? "Absent"
											: salesExecutiveObject.attendence == 2
												? "Holiday"
												: salesExecutiveObject.attendence == 3
													? "Weekly Off"
													: salesExecutiveObject.attendence == 4
														? "Leave"
														: salesExecutiveObject.attendence == 5
															? "Present + Holiday"
															: salesExecutiveObject.attendence == 6
																? "Present + Weekly Off"
																: salesExecutiveObject.attendence == 7
																	? "Present + Weekly Off + Holiday"
																	: "Present + Leave"
									: "",
							isMarkCompOff:
								salesExecutiveObject.isCompOffApplicable !== null
									? salesExecutiveObject.isCompOffApplicable == 1
										? true
										: false
									: "",
							isCompOffApplicable:
								salesExecutiveObject.isCompOffApplicable !== null
									? salesExecutiveObject.isCompOffApplicable
									: "",
							isChecked: false,
						};
						return salesExecutiveData;
					});
					dispatch(salesPersonSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return { response: [], success: false };
		}
	};

export const getSalesTeamByStateForEnquiry =
	({ stateId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/by-state-for-enquiry?stateId=" + stateId,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id == null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderTypePrefix !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.stockStakeHolderTypePrefix +
										")"
									: "",
						};
						return salesExecutiveData;
					});
					dispatch(salesExecutiveSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return { response: [], success: false };
		}
	};

export const getBelowSalesTeamBySalesTeamId =
	({ salesTeamId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/below-team-by-sales-team-id?salesTeamId=" +
					salesTeamId +
					"&flag=1",
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((salesExecutiveObject, index) => {
						let salesExecutiveData = {
							index: index + 1,
							id:
								salesExecutiveObject.id == null ? "" : salesExecutiveObject.id,
							name:
								salesExecutiveObject.name !== null &&
								salesExecutiveObject.stockStakeHolderTypePrefix !== null
									? salesExecutiveObject.name +
										" (" +
										salesExecutiveObject.stockStakeHolderTypePrefix +
										")"
									: "",
						};
						return salesExecutiveData;
					});

					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return { response: [], success: false };
		}
	};
